// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Css for clearable mixin
 */
.ids-input .ids-input-field .btn-clear,
.ids-input .ids-textarea-field .btn-clear,
.ids-textarea .ids-input-field .btn-clear,
.ids-textarea .ids-textarea-field .btn-clear {
  outline: 0;
}
.ids-input .ids-input-field .btn-clear.is-empty,
.ids-input .ids-textarea-field .btn-clear.is-empty,
.ids-textarea .ids-input-field .btn-clear.is-empty,
.ids-textarea .ids-textarea-field .btn-clear.is-empty {
  display: none;
}
.ids-input .ids-input-field .btn-clear [slot=icon],
.ids-input .ids-textarea-field .btn-clear [slot=icon],
.ids-textarea .ids-input-field .btn-clear [slot=icon],
.ids-textarea .ids-textarea-field .btn-clear [slot=icon] {
  margin-inline-start: 0;
  color: inherit;
}
.ids-input.has-clearable .btn-clear.is-empty,
.ids-textarea.has-clearable .btn-clear.is-empty {
  display: none;
  pointer-events: none;
}

.ids-trigger-field .ids-input-field.has-clearable {
  padding-inline-end: 55px;
}
.ids-trigger-field .ids-input-field.has-clearable ~ .btn-clear {
  margin-top: 0;
  right: -8px;
}

.btn-clear[part=clearable-button] [slot=icon] {
  padding: 2px;
}

.icon-dirty {
  --ids-icon-height-default: 12px !important;
  --ids-icon-width-default: 12px !important;
  position: absolute;
  color: var(--ids-input-dirty-indicator-color-background-dirty);
  top: 0;
}
.icon-dirty[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}
.icon-dirty.tab-dirty-tracker {
  inset-inline-start: 0;
}

.ids-color-picker .icon-dirty {
  margin-inline-start: 35px;
}

.ids-color-picker.compact .icon-dirty {
  margin-inline-start: 27px;
}

.ids-textarea .icon-dirty {
  top: 1px;
  margin-inline-start: 1px;
}
.ids-textarea .icon-dirty[dir=rtl] {
  top: 2px;
}

.icon-field-indicator {
  position: absolute;
  top: 0;
  pointer-events: none;
}
.icon-field-indicator[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

.icon-field-indicator-info {
  display: var(--ids-field-indicator-info-visibility, flex);
  align-items: center;
  margin-inline-end: var(--ids-field-indicator-info-margin, var(--ids-space-xs));
  cursor: pointer;
  color: var(--ids-field-indicator-icon-color, --ids-color-info-default);
}

.field-indicator-neutral {
  --ids-field-indicator-icon-color: var(--ids-color-accent-neutral-weak);
}
.field-indicator-neutral .icon-field-indicator {
  color: var(--ids-color-accent-neutral-weak);
}

.field-indicator-info {
  --ids-field-indicator-icon-color: var(--ids-color-info-default);
}
.field-indicator-info .icon-field-indicator {
  color: var(--ids-color-info-default);
}

.field-indicator-success {
  --ids-field-indicator-icon-color: var(--ids-color-success-default);
}
.field-indicator-success .icon-field-indicator {
  color: var(--ids-color-success-default);
}

.field-indicator-caution {
  --ids-field-indicator-icon-color: var(--ids-color-caution-default);
}
.field-indicator-caution .icon-field-indicator {
  color: var(--ids-color-caution-default);
}

.field-indicator-warning {
  --ids-field-indicator-icon-color: var(--ids-color-warning-default);
}
.field-indicator-warning .icon-field-indicator {
  color: var(--ids-color-warning-default);
}

.field-indicator-error {
  --ids-field-indicator-icon-color: var(--ids-color-error-default);
}
.field-indicator-error .icon-field-indicator {
  color: var(--ids-color-error-default);
}

[class*=field-indicator-].has-focus .icon-field-indicator-info {
  display: none;
}

.label-state-hidden .ids-label-text.empty::before {
  content: " ";
}

.label-state-collapsed .ids-label-text {
  display: none;
}

.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

:host([label-position=inline-start]) .ids-input,
:host([label-position=inline-start]) .ids-textarea {
  display: flex;
  align-items: var(--ids-label-align-y, center);
  gap: 8px;
}
:host([label-position=inline-start]) .ids-input label,
:host([label-position=inline-start]) .ids-textarea label {
  width: var(--ids-label-width);
  padding-block: var(--ids-label-padding-block);
  padding-inline-end: 0;
  box-sizing: border-box;
  flex-shrink: 0;
}
:host([label-position=inline-start]) .ids-input .validation-message,
:host([label-position=inline-start]) .ids-textarea .validation-message {
  width: 100%;
  margin-block-start: var(--ids-space-2xs);
}
@media (max-width: 927px) {
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    margin-inline-start: 0;
  }
}
:host([label-position=inline-start]) .ids-input + .validation-message,
:host([label-position=inline-start]) .ids-textarea + .validation-message {
  min-width: min-content;
  margin-block-start: calc(0px - var(--ids-space-2xs));
  margin-inline-start: calc(var(--ids-label-width) + 6px);
}
:host([label-position=inline-start]) .ids-input.xs + .validation-message,
:host([label-position=inline-start]) .ids-textarea.xs + .validation-message {
  position: relative;
  inset-inline-start: 6px;
  margin-inline-start: calc(var(--ids-label-width));
}
:host([label-position=inline-start]) .ids-input .ids-label-text,
:host([label-position=inline-start]) .ids-textarea .ids-label-text {
  margin-bottom: unset;
}
@media (width > 320px) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
  }
}
@container (width > \$breakpoint-xs) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
  }
}
@media (min-width: 767px) {
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label {
    flex: 0 0 auto;
    margin-bottom: unset;
    order: 1;
  }
  :host([label-position=inline-start]) .ids-input .field-container,
  :host([label-position=inline-start]) .ids-textarea .field-container {
    order: 2;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    flex: 1 1 100%;
    min-width: 100%;
    order: 3;
    margin-block-start: calc(0px - var(--ids-space-2xs));
  }
  :host([label-position=inline-start]) .ids-input.wrapped .validation-message,
  :host([label-position=inline-start]) .ids-textarea.wrapped .validation-message {
    margin-block-start: calc(0px - var(--ids-space-2xs));
    margin-inline-start: calc(var(--ids-label-width) + 6px);
  }
}
:host([label-position=inline-start]) .ids-checkbox {
  container-type: inline-size;
  margin-top: var(--ids-space-00);
}
@container (width >= 200px) {
  :host([label-position=inline-start]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: 0;
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + 0.4rem);
    margin-block-start: 3px;
  }
  :host([label-position=inline-start]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    left: unset;
    inset-inline-end: -1.5rem;
  }
  :host([label-position=inline-start]) .ids-checkbox label.required .label-checkbox::after {
    right: 30px;
  }
}

:host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
  container-type: normal;
}
@media (width <= 320px) {
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: 0;
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + 0.4rem);
    margin-block-start: 3px;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    left: unset;
    inset-inline-end: -1.5rem;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox label.required .label-checkbox::after {
    right: 30px;
  }
}

:host([label-position=inline-start][label-alignment=end]) .ids-input label,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label {
    justify-content: flex-start;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label {
    justify-content: flex-start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after {
  margin-inline-end: 0;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea {
    display: block;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea {
    display: block;
  }
}
:host([label-position=inline-start][label-alignment=end]) .field-container {
  flex: 1;
}

:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea {
  display: flex;
  flex-wrap: nowrap;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea label {
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input:not(.xs),
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input:not(.xs) {
  gap: var(--ids-space-2, 0.5rem);
}

:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea {
  display: grid;
  gap: 0;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: var(--ids-space-2, 0.5rem);
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea label {
  grid-column: 1;
  grid-row: 1;
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .field-container {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .validation-message {
  grid-column: 1/-1;
  grid-row: 2;
  width: auto;
  margin-inline-start: 0;
  margin-block-start: var(--ids-space-2xs);
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.wrapped .validation-message {
  grid-column: 2;
  margin-inline-start: 0;
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    display: block;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    flex-wrap: wrap;
  }
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex: 0 1 auto;
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}

:host([label-position=inline-start][label-break=break]) .ids-input,
:host([label-position=inline-start][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-start][label-break=break]) .ids-input label,
:host([label-position=inline-start][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=break]) .ids-input .field-container,
:host([label-position=inline-start][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=break]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}

:host([label-position=inline-start][label-width="0px"]) .ids-label-text,
:host([label-position=inline-start][label-width="0"]) .ids-label-text {
  display: none;
}

:host([label-position=inline-end][label-break=shrink-value]) .ids-input,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea {
  display: flex;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input label,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea label {
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input .field-container,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

@media (width > 320px) {
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    justify-content: end;
    flex: 0 1 auto;
    order: 2;
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    order: 1;
  }
}

:host([label-position=inline-end][label-break=break]) .ids-input,
:host([label-position=inline-end][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-end][label-break=break]) .ids-input label,
:host([label-position=inline-end][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=break]) .ids-input .field-container,
:host([label-position=inline-end][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-end][label-break=break]) .ids-textarea .validation-message {
  margin-inline-start: 0;
  order: 3;
}
:host([label-position=inline-end][label-break=break]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

:host([label-position=inline-start]) {
  --ids-label-width: var(--ids-label-width-inline-start);
}

:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea label {
  align-self: var(--ids-label-align-y, center);
}
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea .ids-label-text {
  overflow: visible;
}

@media (width > 767px) {
  :host([label-position=inline-start]) .ids-textarea {
    max-width: calc(370px + var(--ids-label-width));
  }
  :host([label-position=inline-start]) .ids-textarea .textarea-field {
    width: calc(370px + var(--ids-label-width));
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-filter-field label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-filter-field #operator-button {
    position: relative;
    inset-inline-start: var(--ids-label-width);
  }
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    width: 100%;
    margin-block-start: var(--ids-space-2xs);
  }
}
@media (width < 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: inherit;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-inline-start: initial;
  }
}

@media (min-width: 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    right: initial;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-block-start: 0;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-radio-group,
  :host([label-position=inline-end]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-start]) .ids-radio-group ids-text.group-label-text,
  :host([label-position=inline-end]) .ids-radio-group ids-text.group-label-text {
    min-width: var(--ids-label-width);
  }
  :host([label-position=inline-start]) .ids-radio-group slot,
  :host([label-position=inline-end]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
  }
  :host([label-position=inline-end]) .ids-radio-group ids-text.group-label-text {
    justify-content: end;
    order: 2;
  }
  :host([label-position=inline-end]) .ids-radio-group slot {
    order: 1;
  }
}
@media (width < 767px) {
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
    gap: var(--ids-space-2, 0.5rem);
    flex-direction: column;
  }
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group ids-text.group-label-text {
    min-width: var(--ids-label-width);
    order: 2;
  }
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    order: 1;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-switch {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-switch label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    padding-inline-start: 0;
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-switch input[type=checkbox] ~ .slider {
    left: unset;
    right: -45px;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-switch input[type=checkbox] ~ .slider {
    left: 45px;
    right: initial;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-data-label {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-data-label .label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    margin-block-end: 0;
    white-space: nowrap;
  }
  :host([label-position=inline-start]) .ids-data-label .data,
  :host([label-position=inline-start]) .ids-data-label .description {
    display: flex;
    padding-block: var(--ids-label-padding-block);
  }
}
@media (max-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea,
  :host([label-position=inline-start]) .ids-filter-field {
    display: block;
    flex-direction: column;
    align-items: unset;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label,
  :host([label-position=inline-start]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message,
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
  :host([label-position=inline-end]) .ids-input,
  :host([label-position=inline-end]) .ids-textarea,
  :host([label-position=inline-end]) .ids-filter-field {
    display: block;
    flex-direction: column;
    align-items: unset;
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-end]) .ids-input label,
  :host([label-position=inline-end]) .ids-textarea label,
  :host([label-position=inline-end]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-end]) .ids-input .validation-message,
  :host([label-position=inline-end]) .ids-textarea .validation-message,
  :host([label-position=inline-end]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
}
:host .ids-input label,
:host .ids-input .label,
:host .ids-textarea label,
:host .ids-textarea .label,
:host .ids-checkbox label,
:host .ids-checkbox .label,
:host .ids-radio label,
:host .ids-radio .label,
:host .ids-switch label,
:host .ids-switch .label,
:host .ids-data-label label,
:host .ids-data-label .label,
:host .ids-filter-field label,
:host .ids-filter-field .label {
  width: var(--ids-label-width);
}

/* stylelint-disable */
/* stylelint-enable */
/* in case of external label in compound component */
.ids-label-text {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  color: var(--ids-input-label-color-text-default);
  display: flex;
  margin-block-end: var(--ids-input-margin-bottom);
  align-items: baseline;
  justify-content: inherit;
}
.ids-label-text.ids-box-label {
  display: block;
}
.ids-label-text.empty::before {
  content: " ";
}
.ids-label-text.required::after {
  position: relative;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-inline-start: var(--ids-space-3xs);
  margin-inline-end: var(--ids-space-3xs);
  font-size: var(--ids-font-size-md);
  color: var(--ids-input-required-indicator-color-text-default);
  content: "*";
  margin-top: -10px;
  top: 1px;
  line-height: 0;
}
.ids-label-text.required.no-required-indicator::after, .ids-label-text.required.empty::after {
  content: "";
}
.ids-label-text ids-text::part(text),
.ids-label-text .ids-text {
  display: inline;
}

.disabled .ids-label-text {
  color: var(--ids-input-label-color-text-disabled);
  opacity: var(--ids-input-disabled-opacity);
}
.disabled .ids-label-text.required::after {
  color: var(--ids-input-required-indicator-color-text-disabled);
}

:host {
  display: block;
  max-width: var(--ids-input-width-full);
}
:host .ids-input {
  display: inline-block;
  width: var(--ids-box-input-width, auto);
}

:host([hidden]) {
  display: none;
}

:host([margin-block-end=none]:not([no-margins])) .ids-input,
.ids-input.margin-block-end-none:not(.no-margins) {
  margin-block-end: var(--ids-space-none);
}

:host([margin-block-end="4xs"]:not([no-margins])) .ids-input,
.ids-input.margin-block-end-4xs:not(.no-margins) {
  margin-block-end: var(--ids-space-4xs);
}

:host([margin-block-end="3xs"]:not([no-margins])) .ids-input,
.ids-input.margin-block-end-3xs:not(.no-margins) {
  margin-block-end: var(--ids-space-3xs);
}

:host([margin-block-end="2xs"]:not([no-margins])) .ids-input,
.ids-input.margin-block-end-2xs:not(.no-margins) {
  margin-block-end: var(--ids-space-2xs);
}

:host([margin-block-end=xs]:not([no-margins])) .ids-input,
.ids-input.margin-block-end-xs:not(.no-margins) {
  margin-block-end: var(--ids-space-xs);
}

:host([margin-block-end=sm]:not([no-margins])) .ids-input,
.ids-input.margin-block-end-sm:not(.no-margins) {
  margin-block-end: var(--ids-space-sm);
}

:host([margin-block-end=md]:not([no-margins])) .ids-input,
.ids-input.margin-block-end-md:not(.no-margins) {
  margin-block-end: var(--ids-space-md);
}

:host([margin-block-end=lg]:not([no-margins])) .ids-input,
.ids-input.margin-block-end-lg:not(.no-margins) {
  margin-block-end: var(--ids-space-lg);
}

:host([margin-block-end=xl]:not([no-margins])) .ids-input,
.ids-input.margin-block-end-xl:not(.no-margins) {
  margin-block-end: var(--ids-space-xl);
}

:host([margin-block-end="2xl"]:not([no-margins])) .ids-input,
.ids-input.margin-block-end-2xl:not(.no-margins) {
  margin-block-end: var(--ids-space-2xl);
}

:host([margin-block-end="3xl"]:not([no-margins])) .ids-input,
.ids-input.margin-block-end-3xl:not(.no-margins) {
  margin-block-end: var(--ids-space-3xl);
}

:host([margin-block-end="4xl"]:not([no-margins])) .ids-input,
.ids-input.margin-block-end-4xl:not(.no-margins) {
  margin-block-end: var(--ids-space-4xl);
}

:host([label-position=inline-start]) .field-container {
  justify-content: var(--ids-box-justify-content, flex-start);
}
:host([label-position=inline-start]) .ids-input {
  justify-content: var(--ids-box-justify-content, flex-start);
}

:host([label-position=inline-start][size=full]) .field-container {
  flex: 1;
  min-width: 0;
}

:host([size=full]) {
  width: 100%;
}

:host([label-wrap=wrap]) .ids-label-text {
  overflow-wrap: anywhere;
}

:host([label-wrap=ellipsis]) .ids-label-text {
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host([label-wrap=ellipsis]) .ids-label-text ids-text {
  display: block;
  width: fit-content;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex-shrink: 1;
}
:host([label-wrap=ellipsis]) .ids-label-text.required {
  padding-inline-end: var(--ids-space-xs);
}
:host([label-wrap=ellipsis]) .ids-label-text.required::after {
  flex-shrink: 0;
  margin-inline-start: var(--ids-space-3xs);
}

:host([label-wrap=ellipsis-no-stretch]) .ids-label-text {
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host([label-wrap=ellipsis-no-stretch]) .ids-label-text ids-text {
  display: block;
  width: fit-content;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex-shrink: 1;
}
:host([label-wrap=ellipsis-no-stretch]) .ids-label-text.required {
  padding-inline-end: var(--ids-space-xs);
}
:host([label-wrap=ellipsis-no-stretch]) .ids-label-text.required::after {
  flex-shrink: 0;
  margin-inline-start: var(--ids-space-3xs);
}
:host([label-wrap=ellipsis-no-stretch]) .xs .ids-label-text {
  max-width: calc((var(--ids-input-width-20)) - 8px);
}
:host([label-wrap=ellipsis-no-stretch]) .sm .ids-label-text {
  max-width: calc((var(--ids-input-width-20)) - 8px);
}
:host([label-wrap=ellipsis-no-stretch]) .mm .ids-label-text {
  max-width: calc((var(--ids-input-width-30)) - 8px);
}
:host([label-wrap=ellipsis-no-stretch]) .md .ids-label-text {
  max-width: calc((var(--ids-input-width-40)) - 8px);
}
:host([label-wrap=ellipsis-no-stretch]) .lg .ids-label-text {
  max-width: calc((var(--ids-input-width-50)) - 8px);
}
:host([label-wrap=ellipsis-no-stretch]) .full .ids-label-text {
  max-width: calc(100% - 8px);
}

:host([label-wrap=wrap-no-stretch]) .xs .ids-label-text {
  max-width: calc((var(--ids-input-width-20)) - 8px);
}
:host([label-wrap=wrap-no-stretch]) .sm .ids-label-text {
  max-width: calc((var(--ids-input-width-20)) - 8px);
}
:host([label-wrap=wrap-no-stretch]) .mm .ids-label-text {
  max-width: calc((var(--ids-input-width-30)) - 8px);
}
:host([label-wrap=wrap-no-stretch]) .md .ids-label-text {
  max-width: calc((var(--ids-input-width-40)) - 8px);
}
:host([label-wrap=wrap-no-stretch]) .lg .ids-label-text {
  max-width: calc((var(--ids-input-width-50)) - 8px);
}
:host([label-wrap=wrap-no-stretch]) .full .ids-label-text {
  max-width: calc(100% - 8px);
}
:host([label-wrap=wrap-no-stretch]) .ids-label-text {
  overflow-wrap: anywhere;
}

.ids-input {
  position: relative;
  display: block;
  margin-block-end: var(--ids-space-sm);
  max-width: var(--ids-input-width-full);
}
.ids-input .field-container {
  border: 1px solid;
  border-collapse: separate;
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  color: inherit;
  display: flex;
  align-items: center;
  margin: var(--ids-space-none);
  max-width: var(--ids-input-width-full);
  padding: var(--ids-space-none);
  position: relative;
  resize: none;
  text-align: left;
}
.ids-input .field-container.ff-input-field {
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}
.ids-input .field-container.ff-input-field .ids-input-field {
  color: var(--ids-filter-field-text-color);
}
.ids-input .field-container.square {
  border-radius: var(--ids-border-radius-none);
}
.ids-input:focus-within .ids-input-field, .ids-input.readonly:focus-within .ids-input-field, .ids-input.is-active .ids-input-field {
  outline: none;
  outline-color: var(--ids-color-transparent);
}
.ids-input:focus-within .field-container, .ids-input.readonly:focus-within .field-container, .ids-input.is-active .field-container {
  border-color: var(--ids-input-color-border-focus);
  box-shadow: var(--ids-input-color-border-shadow);
  background-color: var(--ids-input-color-background-default);
}
.ids-input .ids-icon.starting-icon {
  margin-inline-start: var(--ids-space-xs);
}
.ids-input .ids-icon.ending-icon {
  margin-inline-end: var(--ids-space-xs);
}
.ids-input .ids-input-field {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
  background-color: var(--ids-color-transparent);
  border: none;
  color: inherit;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  padding-block-start: var(--ids-space-2xs);
  padding-block-end: var(--ids-space-2xs);
  padding-inline-start: var(--ids-space-12);
  padding-inline-end: var(--ids-input-padding-inline-end);
  font-size: var(--ids-input-font-size);
  width: 100%;
}
.ids-input .ids-input-field:focus-visible {
  outline: none;
}
.ids-input .ids-input-field {
  appearance: none;
  display: inline-block;
  height: fit-content;
  resize: none;
  text-align: left;
  text-overflow: ellipsis;
}
.ids-input .ids-input-field.text-ellipsis {
  text-overflow: ellipsis;
}
.ids-input .ids-input-field.start {
  text-align: start;
}
.ids-input .ids-input-field::placeholder {
  color: var(--ids-input-color-text-placeholder);
}
.ids-input .ids-input-field.center {
  text-align: center;
}
.ids-input .ids-input-field.end {
  text-align: end;
}
.ids-input.event-picker .ids-input-field {
  padding-inline-start: var(--ids-space-xs);
  padding-inline-end: var(--ids-space-2xs);
}
.ids-input .validation-message {
  margin-block-start: var(--ids-space-2xs);
  margin-bottom: var(--ids-space-none);
}
.ids-input .validation-message .ids-icon {
  place-self: self-start;
  margin-top: 1px;
}
.ids-input.no-margins, .ids-input.no-margins.compact {
  display: block;
  margin: var(--ids-space-none);
}
.ids-input.no-margins.field-height-xs, .ids-input.no-margins.compact.field-height-xs {
  margin-block-end: var(--ids-space-none);
}
.ids-input.no-margins .field-container, .ids-input.no-margins.compact .field-container {
  margin-bottom: var(--ids-space-none);
}
.ids-input.no-margins .ids-input-field, .ids-input.no-margins.compact .ids-input-field {
  margin: var(--ids-space-none);
}
.ids-input.no-margins .validation-message, .ids-input.no-margins.compact .validation-message {
  margin-bottom: var(--ids-space-none);
  margin-block-start: var(--ids-space-2xs);
}
.ids-input.no-margins .ids-label-text.empty, .ids-input.no-margins.compact .ids-label-text.empty {
  margin: var(--ids-space-none);
  display: none;
  visibility: hidden;
  height: 0;
}
.ids-input.xs .field-container,
.ids-input.xs .validation-message {
  width: calc(var(--ids-input-width-10));
}
.ids-input.xs .validation-message {
  max-width: calc(var(--ids-input-width-10));
}
.ids-input.sm .field-container {
  width: calc(var(--ids-input-width-20));
}
.ids-input.sm .validation-message {
  max-width: calc(var(--ids-input-width-20));
}
.ids-input.mm .field-container {
  width: calc(var(--ids-input-width-30));
}
.ids-input.mm .validation-message {
  max-width: calc(var(--ids-input-width-30));
}
.ids-input.md .field-container {
  width: calc(var(--ids-input-width-40));
}
.ids-input.md .validation-message {
  max-width: calc(var(--ids-input-width-40));
}
.ids-input.lg .field-container {
  width: calc(var(--ids-input-width-50));
}
.ids-input.lg .validation-message {
  max-width: calc(var(--ids-input-width-50));
}
.ids-input.full {
  display: block;
}
.ids-input.full .field-container,
.ids-input.full .validation-message {
  width: var(--ids-input-width-full);
}
@media (max-width: 767px) {
  .ids-input:not(.full):not(.md):not(.mm):not(.sm):not(.xs):not(.lg) .field-container,
  .ids-input:not(.full):not(.md):not(.mm):not(.sm):not(.xs):not(.lg) .validation-message {
    max-width: calc(var(--ids-input-width-30));
    min-width: auto;
  }
  .ids-input:not(.full):not(.md):not(.mm):not(.sm):not(.xs):not(.lg) .field-container {
    flex-shrink: 0;
    flex-basis: calc(var(--ids-input-width-30));
    box-sizing: border-box;
  }
}
.ids-input.field-height-xs {
  margin-block-end: var(--ids-font-size-2xs);
}
.ids-input.field-height-xs .icon-dirty {
  top: 0;
}
.ids-input.field-height-xs .ids-label-text {
  font-size: var(--ids-input-label-font-size);
}
.ids-input.field-height-xs .ids-input-field {
  padding-inline-start: var(--ids-space-2xs);
  padding-inline-end: var(--ids-space-2xs);
  padding-top: 0;
  padding-bottom: 0;
  font-size: var(--ids-input-font-size-sm);
  height: calc(var(--ids-input-height-10) - 4px);
}
.ids-input.field-height-xs.no-margin-bottom {
  margin-bottom: var(--ids-space-none);
}
.ids-input.field-height-xs.no-margin-bottom .field-container,
.ids-input.field-height-xs.no-margin-bottom .ids-input-field {
  margin-bottom: var(--ids-space-none);
}
.ids-input.field-height-sm .ids-input-field {
  height: calc(var(--ids-input-height-20) - 2px);
}
.ids-input.field-height-md .ids-input-field {
  height: calc(var(--ids-input-height-30) - 2px);
}
.ids-input.field-height-lg .ids-input-field {
  height: calc(var(--ids-input-height-40) - 2px);
}
.ids-input.compact {
  margin-block-end: var(--ids-font-size-2xs);
}
.ids-input.compact .icon-dirty {
  top: 0;
}
.ids-input.compact .ids-label-text {
  font-size: var(--ids-input-label-font-size);
}
.ids-input.compact .ids-input-field {
  padding-inline-start: var(--ids-space-2xs);
  padding-inline-end: var(--ids-space-2xs);
  padding-top: 0;
  padding-bottom: 0;
  font-size: var(--ids-input-font-size-sm);
  height: calc(var(--ids-input-height-10) - 4px);
}
.ids-input.compact.no-margin-bottom {
  margin-bottom: var(--ids-space-none);
}
.ids-input.compact.no-margin-bottom .field-container,
.ids-input.compact.no-margin-bottom .ids-input-field {
  margin-bottom: var(--ids-space-none);
  height: calc(var(--ids-input-height-10) - 4px);
}
.ids-input.compact .field-container:not(.ff-input-field) {
  height: calc(var(--ids-input-height-10) - 2px);
}
.ids-input.color-variant-borderless {
  --ids-input-color-border-focus: var(--ids-color-transparent);
  margin: 1px;
  border-radius: var(--ids-border-radius-none);
}
.ids-input.color-variant-borderless input {
  font-size: var(--ids-font-size-sm);
}
.ids-input.color-variant-borderless slot[name=trigger-start],
.ids-input.color-variant-borderless slot[name=trigger-end] {
  display: flex;
}
.ids-input.color-variant-borderless .ids-label-text {
  display: none;
}
.ids-input.color-variant-borderless .icon-dirty {
  display: none;
}
.ids-input.color-variant-borderless .validation-message {
  display: none;
}
.ids-input.color-variant-borderless .field-container {
  background-color: var(--ids-color-transparent) !important;
  border-color: transparent !important;
}
.ids-input.color-variant-borderless:focus-within .field-container {
  box-shadow: none;
}
.ids-input.color-variant-borderless.ids-input.field-height-lg .ids-input-field {
  padding-inline: calc(var(--ids-space-sm) - 2px);
}
.ids-input.color-variant-borderless.ids-input.field-height-md .ids-input-field {
  padding-inline: calc(var(--ids-space-12) - 2px);
}
.ids-input.color-variant-borderless.ids-input.field-height-sm .ids-input-field {
  padding-inline: calc(var(--ids-space-xs) - 2px);
}
.ids-input.color-variant-borderless.ids-input.field-height-xs .ids-input-field {
  font-size: var(--ids-data-grid-font-size-sm);
  padding-inline: var(--ids-space-3xs);
}
.ids-input.color-variant-borderless.ids-input.field-height-xs slot[name=trigger-end] {
  padding-inline-end: var(--ids-space-none);
}
.ids-input.color-variant-borderless.ids-input.field-height-xxs .ids-input-field {
  font-size: var(--ids-data-grid-font-size-sm);
  padding-inline: var(--ids-space-4xs);
}
.ids-input.color-variant-borderless.ids-input.field-height-xxs slot[name=trigger-end] {
  padding-inline-end: var(--ids-space-none);
}
.ids-input.color-variant-in-cell {
  margin: 1px;
}
.ids-input.color-variant-in-cell input {
  font-size: var(--ids-font-size-sm);
}
.ids-input.color-variant-in-cell input[field-height=xxs] {
  --ids-dropdown-font-size-compact: var(--ids-data-grid-font-size-sm);
  font-size: var(--ids-data-grid-font-size-sm);
  padding-inline-start: 2px;
}
.ids-input.color-variant-in-cell .validation-message {
  display: none;
}
.ids-input.color-variant-in-cell.ids-input.field-height-lg .ids-input-field {
  padding-inline: 11px;
  height: 40px;
}
.ids-input.color-variant-in-cell.ids-input.full .field-container {
  margin-inline: 3px;
  width: initial;
}
.ids-input.color-variant-in-cell.ids-input.field-height-md .ids-input-field {
  padding-inline: 6px;
  height: 30px;
}
.ids-input.color-variant-in-cell.ids-input.field-height-sm .ids-input-field {
  padding-inline: var(--ids-space-2xs);
  height: 27px;
}
.ids-input.color-variant-in-cell.ids-input.field-height-sm.full .field-container {
  margin-inline: var(--ids-space-3xs);
}
.ids-input.color-variant-in-cell.ids-input.field-height-xs .ids-input-field {
  padding-inline: 1px;
  height: 24px;
}
.ids-input.color-variant-in-cell.ids-input.field-height-xs.full .field-container {
  margin-inline: 1px;
}
.ids-input.color-variant-module-nav {
  margin-block-end: var(--ids-space-none);
  transform: background-color var(--ids-motion-duration) var(--ids-motion-ease), border-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-input.color-variant-module-nav .field-container {
  border-radius: var(--ids-module-nav-common-border-radius);
  border: var(--ids-module-nav-input-border-width) solid transparent;
}
.ids-input.color-variant-module-nav input {
  background-color: var(--ids-color-transparent);
  color: inherit;
}
.ids-input.color-variant-module-nav input::placeholder {
  color: var(--ids-module-nav-search-input-placeholder-text-color);
}
.ids-input.color-variant-module-nav input:active {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-input.color-variant-module-nav:not([class*=field-height-]) {
  height: var(--ids-module-nav-search-wrapper-height);
}
.ids-input.color-variant-module-nav:not([class*=field-height-]) input {
  height: var(--ids-module-nav-search-input-height);
}
.ids-input:not([class*=color-variant-]) .field-container:not(:focus-within) {
  background-color: var(--ids-input-color-background-default);
  border-color: var(--ids-input-border-default-color);
  color: var(--ids-input-color-text-default);
}
.ids-input:not([class*=color-variant-]).readonly .field-container.error, .ids-input:not([class*=color-variant-]).readonly .field-container.error:hover, .ids-input:not([class*=color-variant-]).readonly.hover .field-container.error, .ids-input:not([class*=color-variant-]).readonly.hover .field-container.error:hover, .ids-input:not([class*=color-variant-]).readonly.focus-within .field-container.error, .ids-input:not([class*=color-variant-]).readonly.focus-within .field-container.error:hover {
  border-color: var(--ids-color-error-default);
  color: var(--ids-color-error-default);
}
.ids-input:not([class*=color-variant-]).readonly:not(.readonly-background):not(.bg-transparent) .field-container, .ids-input:not([class*=color-variant-]).readonly:not(.readonly-background):not(.bg-transparent).hover .field-container, .ids-input:not([class*=color-variant-]).readonly:not(.readonly-background):not(.bg-transparent).focus-within .field-container {
  background-color: var(--ids-input-color-background-readonly);
}
.ids-input:not([class*=color-variant-]).disabled .field-container, .ids-input:not([class*=color-variant-]).disabled:hover .field-container, .ids-input:not([class*=color-variant-]).disabled:focus-within .field-container {
  border-color: var(--ids-input-color-border-disabled);
  color: var(--ids-input-color-text-disabled);
  opacity: var(--ids-input-disabled-opacity);
  -webkit-text-fill-color: var(--ids-input-color-text-disabled);
}
.ids-input:not([class*=color-variant-]).bg-transparent .field-container, .ids-input:not([class*=color-variant-]).bg-transparent.readonly .field-container, .ids-input:not([class*=color-variant-]).bg-transparent.disabled .field-container {
  background-color: var(--ids-color-transparent);
}
.ids-input:not([class*=color-variant-]).bg-transparent:focus-within .field-container {
  background-color: var(--ids-color-transparent);
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .field-container, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .field-container {
  border-color: var(--ids-input-color-border-hover);
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .alert,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .alert:hover,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .warning,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .warning:hover, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .alert,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .alert:hover,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .warning,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .warning:hover {
  border-color: var(--ids-input-color-border-alert-default);
  color: var(--ids-input-color-text-alert-default);
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .alert:focus-within, .ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .alert.is-active,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .alert:hover:focus-within,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .alert:hover.is-active,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .warning:focus-within,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .warning.is-active,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .warning:hover:focus-within,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .warning:hover.is-active, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .alert:focus-within, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .alert.is-active,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .alert:hover:focus-within,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .alert:hover.is-active,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .warning:focus-within,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .warning.is-active,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .warning:hover:focus-within,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .warning:hover.is-active {
  border-color: var(--ids-input-color-border-alert-default);
  box-shadow: var(--ids-input-shadow-alert-focus) 0 0 3px 2px;
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .alert[disabled],
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .alert:hover[disabled],
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .warning[disabled],
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .warning:hover[disabled], .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .alert[disabled],
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .alert:hover[disabled],
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .warning[disabled],
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .warning:hover[disabled] {
  border-color: var(--ids-input-color-border-alert-disabled);
  color: var(--ids-input-color-text-alert-disabled);
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .field-container.error,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .field-container.error:hover, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .field-container.error,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .field-container.error:hover {
  border-color: var(--ids-input-color-border-error-default);
  color: var(--ids-input-error-color-text-error-default);
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .field-container.error.field-container:not(:focus-within),
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .field-container.error:hover.field-container:not(:focus-within), .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .field-container.error.field-container:not(:focus-within),
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .field-container.error:hover.field-container:not(:focus-within) {
  border-color: var(--ids-input-color-border-error-default);
  color: var(--ids-input-error-color-text-error-default);
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .field-container.error:focus-within, .ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .field-container.error.is-active,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .field-container.error:hover:focus-within,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .field-container.error:hover.is-active, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .field-container.error:focus-within, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .field-container.error.is-active,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .field-container.error:hover:focus-within,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .field-container.error:hover.is-active {
  border-color: var(--ids-input-color-border-error-default);
  box-shadow: var(--ids-input-color-shadow-error-focus) 0 0 3px 2px;
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .field-container.error[disabled],
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .field-container.error:hover[disabled], .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .field-container.error[disabled],
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .field-container.error:hover[disabled] {
  border-color: var(--ids-input-color-border-error-disabled);
  color: var(--ids-input-color-border-error-disabled);
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .info,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .info:hover, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .info,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .info:hover {
  border-color: var(--ids-input-color-border-info-default);
  color: var(--ids-input-color-text-info-default);
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .info:focus-within, .ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .info.is-active,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .info:hover:focus-within,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .info:hover.is-active, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .info:focus-within, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .info.is-active,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .info:hover:focus-within,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .info:hover.is-active {
  border-color: var(--ids-input-color-border-info-default);
  box-shadow: var(--ids-input-shadow-info-focus) 0 0 3px 2px;
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .info[disabled],
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .info:hover[disabled], .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .info[disabled],
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .info:hover[disabled] {
  border-color: var(--ids-input-color-border-info-disabled);
  color: var(--ids-input-color-text-info-disabled);
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .success,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .success:hover, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .success,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .success:hover {
  border-color: var(--ids-input-color-border-success-default);
  color: var(--ids-input-color-text-success-default);
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .success:focus-within, .ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .success.is-active,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .success:hover:focus-within,
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .success:hover.is-active, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .success:focus-within, .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .success.is-active,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .success:hover:focus-within,
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .success:hover.is-active {
  border-color: var(--ids-input-color-border-success-default);
  box-shadow: var(--ids-input-shadow-success-focus) 0 0 3px 2px;
}
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .success[disabled],
.ids-input:not([class*=color-variant-]):hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within) .success:hover[disabled], .ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .success[disabled],
.ids-input:not([class*=color-variant-]):hover.readonly.readonly-background:not(:focus):not(:focus-within) .success:hover[disabled] {
  border-color: var(--ids-input-color-border-success-disabled);
  color: var(--ids-input-color-text-success-disabled);
}
.ids-input:not([class*=color-variant-]).is-active .field-container, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .field-container {
  border-color: var(--ids-input-color-border-focus);
}
.ids-input:not([class*=color-variant-]).is-active .alert,
.ids-input:not([class*=color-variant-]).is-active .alert:hover,
.ids-input:not([class*=color-variant-]).is-active .warning,
.ids-input:not([class*=color-variant-]).is-active .warning:hover, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .alert,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .alert:hover,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .warning,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .warning:hover {
  border-color: var(--ids-input-color-border-alert-default);
  color: var(--ids-input-color-text-alert-default);
}
.ids-input:not([class*=color-variant-]).is-active .alert:focus-within, .ids-input:not([class*=color-variant-]).is-active .alert.is-active,
.ids-input:not([class*=color-variant-]).is-active .alert:hover:focus-within,
.ids-input:not([class*=color-variant-]).is-active .alert:hover.is-active,
.ids-input:not([class*=color-variant-]).is-active .warning:focus-within,
.ids-input:not([class*=color-variant-]).is-active .warning.is-active,
.ids-input:not([class*=color-variant-]).is-active .warning:hover:focus-within,
.ids-input:not([class*=color-variant-]).is-active .warning:hover.is-active, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .alert:focus-within, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .alert.is-active,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .alert:hover:focus-within,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .alert:hover.is-active,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .warning:focus-within,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .warning.is-active,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .warning:hover:focus-within,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .warning:hover.is-active {
  border-color: var(--ids-input-color-border-alert-default);
  box-shadow: var(--ids-input-shadow-alert-focus) 0 0 3px 2px;
}
.ids-input:not([class*=color-variant-]).is-active .alert[disabled],
.ids-input:not([class*=color-variant-]).is-active .alert:hover[disabled],
.ids-input:not([class*=color-variant-]).is-active .warning[disabled],
.ids-input:not([class*=color-variant-]).is-active .warning:hover[disabled], .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .alert[disabled],
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .alert:hover[disabled],
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .warning[disabled],
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .warning:hover[disabled] {
  border-color: var(--ids-input-color-border-alert-disabled);
  color: var(--ids-input-color-text-alert-disabled);
}
.ids-input:not([class*=color-variant-]).is-active .field-container.error,
.ids-input:not([class*=color-variant-]).is-active .field-container.error:hover, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .field-container.error,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .field-container.error:hover {
  border-color: var(--ids-input-color-border-error-default);
  color: var(--ids-input-error-color-text-error-default);
}
.ids-input:not([class*=color-variant-]).is-active .field-container.error.field-container:not(:focus-within),
.ids-input:not([class*=color-variant-]).is-active .field-container.error:hover.field-container:not(:focus-within), .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .field-container.error.field-container:not(:focus-within),
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .field-container.error:hover.field-container:not(:focus-within) {
  border-color: var(--ids-input-color-border-error-default);
  color: var(--ids-input-error-color-text-error-default);
}
.ids-input:not([class*=color-variant-]).is-active .field-container.error:focus-within, .ids-input:not([class*=color-variant-]).is-active .field-container.error.is-active,
.ids-input:not([class*=color-variant-]).is-active .field-container.error:hover:focus-within,
.ids-input:not([class*=color-variant-]).is-active .field-container.error:hover.is-active, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .field-container.error:focus-within, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .field-container.error.is-active,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .field-container.error:hover:focus-within,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .field-container.error:hover.is-active {
  border-color: var(--ids-input-color-border-error-default);
  box-shadow: var(--ids-input-color-shadow-error-focus) 0 0 3px 2px;
}
.ids-input:not([class*=color-variant-]).is-active .field-container.error[disabled],
.ids-input:not([class*=color-variant-]).is-active .field-container.error:hover[disabled], .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .field-container.error[disabled],
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .field-container.error:hover[disabled] {
  border-color: var(--ids-input-color-border-error-disabled);
  color: var(--ids-input-color-border-error-disabled);
}
.ids-input:not([class*=color-variant-]).is-active .info,
.ids-input:not([class*=color-variant-]).is-active .info:hover, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .info,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .info:hover {
  border-color: var(--ids-input-color-border-info-default);
  color: var(--ids-input-color-text-info-default);
}
.ids-input:not([class*=color-variant-]).is-active .info:focus-within, .ids-input:not([class*=color-variant-]).is-active .info.is-active,
.ids-input:not([class*=color-variant-]).is-active .info:hover:focus-within,
.ids-input:not([class*=color-variant-]).is-active .info:hover.is-active, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .info:focus-within, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .info.is-active,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .info:hover:focus-within,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .info:hover.is-active {
  border-color: var(--ids-input-color-border-info-default);
  box-shadow: var(--ids-input-shadow-info-focus) 0 0 3px 2px;
}
.ids-input:not([class*=color-variant-]).is-active .info[disabled],
.ids-input:not([class*=color-variant-]).is-active .info:hover[disabled], .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .info[disabled],
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .info:hover[disabled] {
  border-color: var(--ids-input-color-border-info-disabled);
  color: var(--ids-input-color-text-info-disabled);
}
.ids-input:not([class*=color-variant-]).is-active .success,
.ids-input:not([class*=color-variant-]).is-active .success:hover, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .success,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .success:hover {
  border-color: var(--ids-input-color-border-success-default);
  color: var(--ids-input-color-text-success-default);
}
.ids-input:not([class*=color-variant-]).is-active .success:focus-within, .ids-input:not([class*=color-variant-]).is-active .success.is-active,
.ids-input:not([class*=color-variant-]).is-active .success:hover:focus-within,
.ids-input:not([class*=color-variant-]).is-active .success:hover.is-active, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .success:focus-within, .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .success.is-active,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .success:hover:focus-within,
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .success:hover.is-active {
  border-color: var(--ids-input-color-border-success-default);
  box-shadow: var(--ids-input-shadow-success-focus) 0 0 3px 2px;
}
.ids-input:not([class*=color-variant-]).is-active .success[disabled],
.ids-input:not([class*=color-variant-]).is-active .success:hover[disabled], .ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .success[disabled],
.ids-input:not([class*=color-variant-]).is-active:hover.readonly.readonly-background .success:hover[disabled] {
  border-color: var(--ids-input-color-border-success-disabled);
  color: var(--ids-input-color-text-success-disabled);
}
.ids-input:not([class*=color-variant-]):hover:not(.disabled).readonly.readonly-background.color-variant-alternate-formatter .field-container {
  border-color: var(--ids-data-grid-filter-input-color-border-hover);
}
.ids-input:not([class*=color-variant-]) .alert,
.ids-input:not([class*=color-variant-]) .alert:hover,
.ids-input:not([class*=color-variant-]) .warning,
.ids-input:not([class*=color-variant-]) .warning:hover {
  border-color: var(--ids-input-color-border-alert-default);
  color: var(--ids-input-color-text-alert-default);
}
.ids-input:not([class*=color-variant-]) .alert:focus-within, .ids-input:not([class*=color-variant-]) .alert.is-active,
.ids-input:not([class*=color-variant-]) .alert:hover:focus-within,
.ids-input:not([class*=color-variant-]) .alert:hover.is-active,
.ids-input:not([class*=color-variant-]) .warning:focus-within,
.ids-input:not([class*=color-variant-]) .warning.is-active,
.ids-input:not([class*=color-variant-]) .warning:hover:focus-within,
.ids-input:not([class*=color-variant-]) .warning:hover.is-active {
  border-color: var(--ids-input-color-border-alert-default);
  box-shadow: var(--ids-input-shadow-alert-focus) 0 0 3px 2px;
}
.ids-input:not([class*=color-variant-]) .alert[disabled],
.ids-input:not([class*=color-variant-]) .alert:hover[disabled],
.ids-input:not([class*=color-variant-]) .warning[disabled],
.ids-input:not([class*=color-variant-]) .warning:hover[disabled] {
  border-color: var(--ids-input-color-border-alert-disabled);
  color: var(--ids-input-color-text-alert-disabled);
}
.ids-input:not([class*=color-variant-]) .field-container.error,
.ids-input:not([class*=color-variant-]) .field-container.error:hover {
  border-color: var(--ids-input-color-border-error-default);
  color: var(--ids-input-error-color-text-error-default);
}
.ids-input:not([class*=color-variant-]) .field-container.error.field-container:not(:focus-within),
.ids-input:not([class*=color-variant-]) .field-container.error:hover.field-container:not(:focus-within) {
  border-color: var(--ids-input-color-border-error-default);
  color: var(--ids-input-error-color-text-error-default);
}
.ids-input:not([class*=color-variant-]) .field-container.error:focus-within, .ids-input:not([class*=color-variant-]) .field-container.error.is-active,
.ids-input:not([class*=color-variant-]) .field-container.error:hover:focus-within,
.ids-input:not([class*=color-variant-]) .field-container.error:hover.is-active {
  border-color: var(--ids-input-color-border-error-default);
  box-shadow: var(--ids-input-color-shadow-error-focus) 0 0 3px 2px;
}
.ids-input:not([class*=color-variant-]) .field-container.error[disabled],
.ids-input:not([class*=color-variant-]) .field-container.error:hover[disabled] {
  border-color: var(--ids-input-color-border-error-disabled);
  color: var(--ids-input-color-border-error-disabled);
}
.ids-input:not([class*=color-variant-]) .info,
.ids-input:not([class*=color-variant-]) .info:hover {
  border-color: var(--ids-input-color-border-info-default);
  color: var(--ids-input-color-text-info-default);
}
.ids-input:not([class*=color-variant-]) .info:focus-within, .ids-input:not([class*=color-variant-]) .info.is-active,
.ids-input:not([class*=color-variant-]) .info:hover:focus-within,
.ids-input:not([class*=color-variant-]) .info:hover.is-active {
  border-color: var(--ids-input-color-border-info-default);
  box-shadow: var(--ids-input-shadow-info-focus) 0 0 3px 2px;
}
.ids-input:not([class*=color-variant-]) .info[disabled],
.ids-input:not([class*=color-variant-]) .info:hover[disabled] {
  border-color: var(--ids-input-color-border-info-disabled);
  color: var(--ids-input-color-text-info-disabled);
}
.ids-input:not([class*=color-variant-]) .success,
.ids-input:not([class*=color-variant-]) .success:hover {
  border-color: var(--ids-input-color-border-success-default);
  color: var(--ids-input-color-text-success-default);
}
.ids-input:not([class*=color-variant-]) .success:focus-within, .ids-input:not([class*=color-variant-]) .success.is-active,
.ids-input:not([class*=color-variant-]) .success:hover:focus-within,
.ids-input:not([class*=color-variant-]) .success:hover.is-active {
  border-color: var(--ids-input-color-border-success-default);
  box-shadow: var(--ids-input-shadow-success-focus) 0 0 3px 2px;
}
.ids-input:not([class*=color-variant-]) .success[disabled],
.ids-input:not([class*=color-variant-]) .success:hover[disabled] {
  border-color: var(--ids-input-color-border-success-disabled);
  color: var(--ids-input-color-text-success-disabled);
}
.ids-input.color-variant-alternate .field-container {
  border-color: var(--ids-input-header-color-border);
  color: var(--ids-input-header-color-text-default);
  background-color: var(--ids-input-header-color-background);
  border-bottom: 1px solid var(--ids-input-header-color-border);
  box-shadow: none;
}
.ids-input.color-variant-alternate:focus-within .field-container {
  border-color: var(--ids-input-color-border-focus);
  box-shadow: var(--ids-input-color-border-shadow);
}
.ids-input.color-variant-alternate .ids-input-field {
  color: var(--ids-input-header-color-text-default);
}
.ids-input.color-variant-alternate .ids-input-field::placeholder {
  color: var(--ids-input-header-color-text-placeholder);
}
.ids-input.color-variant-alternate.readonly-background .ids-input-field::placeholder {
  color: var(--ids-input-header-color-text-placeholder);
}
.ids-input.color-variant-alternate-formatter .field-container {
  background-color: var(--ids-data-grid-filter-input-color-background);
  border-color: var(--ids-data-grid-filter-input-color-border-default);
  color: var(--ids-data-grid-filter-input-color-text-default);
}
.ids-input.color-variant-alternate-formatter:hover.readonly.readonly-background .field-container, .ids-input.color-variant-alternate-formatter:hover:not(.readonly):not(.disabled) .field-container {
  border-color: var(--ids-data-grid-filter-input-color-border-hover);
}
.ids-input.color-variant-alternate-formatter:focus-within .field-container, .ids-input.color-variant-alternate-formatter:focus-within:hover.readonly.readonly-background, .ids-input.color-variant-alternate-formatter:focus-within:hover:not(.readonly):not(.disabled) .field-container {
  border-color: var(--ids-data-grid-filter-input-color-border-focus);
}
.ids-input.color-variant-alternate-formatter:focus-within .ids-input-field {
  box-shadow: var(--ids-input-color-border-shadow);
}
.ids-input.color-variant-alternate-formatter.disabled .field-container, .ids-input.color-variant-alternate-formatter.disabled:hover .field-container {
  border-color: var(--ids-data-grid-filter-input-color-border-disabled);
  color: var(--ids-data-grid-filter-input-color-text-disabled);
}
.ids-input.color-variant-alternate-formatter.readonly:not(.readonly-background):not(.bg-transparent) .field-container {
  background-color: var(--ids-data-grid-filter-input-color-background-readonly);
  border-color: var(--ids-data-grid-filter-input-color-border-readonly);
  color: var(--ids-data-grid-filter-input-color-text-readonly);
}
.ids-input.color-variant-alternate-formatter .ids-input-field::placeholder {
  color: var(--ids-data-grid-filter-input-color-text-placeholder);
}
.ids-input.color-variant-app-menu .field-container {
  color: var(--ids-input-color-text-app-menu);
}
.ids-input.color-variant-list-builder .field-container {
  background-color: var(--ids-color-transparent);
  color: var(--ids-list-builder-input-text-color);
  border: 0;
}
.ids-input {
  /* stylelint-disable-next-line no-duplicate-selectors */
}
.ids-input.color-variant-module-nav {
  color: var(--ids-module-nav-search-input-text-color);
  /* stylelint-disable-next-line no-duplicate-selectors */
}
.ids-input.color-variant-module-nav .field-container {
  background-color: var(--ids-color-transparent);
  border-color: var(--ids-color-transparent);
  color: inherit;
}
.ids-input.color-variant-module-nav .ids-input-field {
  background-color: var(--ids-color-transparent);
  color: inherit;
}
.ids-input.color-variant-module-nav .ids-input-field::placeholder {
  color: var(--ids-module-nav-search-input-placeholder-text-color);
}
.ids-input.color-variant-module-nav .ids-input-field:active {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-input.color-variant-module-nav.has-clearable .btn-clear {
  margin-inline-end: 5px;
}
.ids-input.color-variant-module-nav:hover .field-container {
  background-color: var(--ids-module-nav-search-input-hover-bg-color);
}
.ids-input.color-variant-module-nav:hover .ids-input-field::placeholder {
  color: var(--ids-module-nav-search-input-placeholder-text-color);
}
.ids-input.color-variant-module-nav:hover .ids-input-field {
  color: var(--ids-module-nav-input-text-color);
}
.ids-input.color-variant-module-nav:focus-within .field-container, .ids-input.color-variant-module-nav.readonly:focus-within .field-container, .ids-input.color-variant-module-nav.is-active .field-container {
  background-color: var(--ids-module-nav-input-focus-bg-color);
  border-color: var(--ids-module-nav-item-selected-text-color);
  box-shadow: none;
}
.ids-input.color-variant-module-nav:focus-within .ids-input-field::placeholder, .ids-input.color-variant-module-nav.readonly:focus-within .ids-input-field::placeholder, .ids-input.color-variant-module-nav.is-active .ids-input-field::placeholder {
  color: var(--ids-module-nav-search-input-focused-placeholder-text-color);
}
.ids-input.color-variant-module-nav:focus-within .ids-input-field, .ids-input.color-variant-module-nav.readonly:focus-within .ids-input-field, .ids-input.color-variant-module-nav.is-active .ids-input-field {
  color: var(--ids-module-nav-input-text-color);
}

:host(.tab-name-editor) .ids-input {
  margin-block-end: unset;
}
:host(.tab-name-editor) .ids-label-text {
  display: none;
}

.caps-lock-indicator {
  padding-inline-start: var(--ids-space-xs);
  padding-inline-end: var(--ids-space-xs);
}

.show-hide-password {
  padding-inline-end: var(--ids-space-3xs);
}

.is-uppercase {
  text-transform: uppercase;
}

.is-lowercase {
  text-transform: lowercase;
}

.highlight {
  font-weight: var(--ids-font-weight-bold);
}

.ids-input-field[type=number]::-webkit-inner-spin-button,
.ids-input-field[type=number]::-webkit-outer-spin-button {
  appearance: none;
}

.ids-input-field::-webkit-caps-lock-indicator {
  visibility: hidden;
}

:host ids-popup[type=dropdown] {
  width: 100%;
  max-width: var(--ids-input-width-40);
}

:host(:not([show-loading-indicator=true])) ::slotted(.slot-loading-indicator) {
  display: none;
}

:host([show-loading-indicator=true]) {
  pointer-events: none;
}
:host([show-loading-indicator=true]) ::slotted(ids-loading-indicator) {
  margin-top: 3px;
  margin-bottom: 3px;
}
:host([show-loading-indicator=true]) ::slotted(ids-trigger-button[slot=trigger-end]) {
  display: none;
}
:host([show-loading-indicator=true]) ::slotted(.slot-loading-indicator) {
  margin-inline-end: 12px;
  margin-inline-start: var(--ids-space-xs);
}

:host([show-loading-indicator=true][field-height=xs]) ::slotted(.slot-loading-indicator) {
  margin-inline-start: var(--ids-space-2xs);
  margin-inline-end: var(--ids-space-2xs);
}

:host([show-loading-indicator=true][field-height=sm]) ::slotted(.slot-loading-indicator) {
  margin-inline-end: var(--ids-space-xs);
  margin-inline-start: var(--ids-space-2xs);
}

::slotted(.audible) {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  color: var(--ids-color-text-default);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

:host([field-indicator][readonly]),
:host([field-indicator][disabled]) {
  --ids-field-indicator-info-visibility: none;
}

.icon-error-tracker {
  position: absolute;
  color: var(--ids-input-error-tracker-color-background, var(--ids-color-red-60));
  top: 0;
  pointer-events: none;
}
.icon-error-tracker[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

:host([part=trigger-field]) {
  justify-content: flex-start;
}

:host([data-filter-type]) {
  --ids-trigger-field-min-width: 40px;
  margin-inline-end: 0;
}
:host([data-filter-type]) ::slotted(ids-trigger-button) {
  margin-inline-end: 6px;
}

.ids-trigger-field {
  justify-content: inherit;
}
.ids-trigger-field.compact .field-container, .ids-trigger-field.field-height-xs .field-container {
  height: calc(var(--ids-input-height-10) - 2px);
}
.ids-trigger-field .field-container.square,
.ids-trigger-field .filter-container.square {
  border-radius: 0;
}
.ids-trigger-field .field-container {
  min-width: var(--ids-trigger-field-min-width);
  /* Ensure dirty tracker icon stays visible */
}
.ids-trigger-field .field-container .icon-dirty {
  pointer-events: none;
  z-index: 1;
}
.ids-trigger-field .field-container {
  /* Ensure error tracker icon stays visible */
}
.ids-trigger-field .field-container .icon-error-tracker {
  pointer-events: none;
  z-index: 1;
}

::slotted(*[slot=trigger-end]:not(.spinbox-button)) {
  margin-inline-end: 4px;
  width: 24px;
}

::slotted(*[slot=trigger-end].xs) {
  margin-inline-end: 4px;
  width: 24px;
}

::slotted(*[slot=trigger-end].md) {
  margin-inline-end: 4px;
  width: 24px;
  height: 24px;
  margin-top: 2px;
  margin-bottom: 2px;
}

::slotted(*[slot=trigger-end][compact]) {
  margin-inline-end: 6px;
  width: 24px;
}

.ids-input.color-variant-alternate-formatter:focus-within .field-container.is-focused {
  border-color: var(--ids-color-border-focus);
  box-shadow: var(--ids-accordion-header-shadow-focus);
}
.ids-input.color-variant-alternate-formatter:focus-within .field-container.hide-focus {
  box-shadow: none;
  border-color: var(--ids-data-grid-filter-input-color-background-readonly);
}
.ids-input.color-variant-alternate-formatter:focus-within .ids-input-field {
  box-shadow: none;
}

.field-container.collapsed .btn-clear {
  display: none;
}

.ids-input.color-variant-module-nav .field-container.is-focused {
  outline: 1px solid var(--ids-module-nav-item-active-border-color);
}
.ids-input.color-variant-module-nav .field-container.hide-focus {
  outline: none;
}

:host(:not([collapsed])) ::slotted(ids-trigger-button.expand-button) {
  display: none;
}

:host([collapsed]) ::slotted(ids-trigger-button.expand-button) {
  display: block;
  position: relative;
  top: var(--ids-trigger-button-offset-top, 0);
}

:host([combobox]) .field-container input {
  border-inline-end: 1px solid var(--ids-trigger-field-combobox-border);
}
:host([combobox]) ::slotted(ids-trigger-button) {
  width: 32px;
}

.ids-search-field:focus-within ids-input::part(input) {
  box-shadow: none;
}

@media (max-width: 767px) {
  :host {
    overflow: hidden;
  }
}
:host ids-menu-button {
  transition: border var(--ids-motion-duration) var(--ids-motion-ease);
  border: 0;
  border-inline: 0;
  border-inline-end: 1px solid var(--ids-search-field-color-border-default);
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin: 0;
  margin-inline: 0;
  padding: 0;
  padding-inline: 0;
}
:host ids-menu-button > * {
  display: inline-flex;
  align-self: center;
  inset-inline-start: 5px;
}
:host ids-menu-button::part(button) {
  border: 0;
  border-radius: 0;
  margin: 0;
  margin-inline: 0;
  padding: 0;
  padding-inline: 0;
  padding-inline: var(--ids-search-field-icon-margin);
}
:host ids-menu-button::part(button), :host ids-menu-button::part(button):active, :host ids-menu-button::part(button):hover {
  background: var(--ids-color-transparent);
  background-color: var(--ids-color-transparent);
}

:host([category]) ids-menu-button {
  --ids-button-tertiary-shadow-focus: var(--ids-shadow-focus);
}
:host([category]) ids-menu-button > * {
  inset-inline-start: 0;
}

:host(:focus-within) ids-menu-button,
:host(:focus-visible) ids-menu-button {
  border-color: var(--ids-search-field-color-border-focus);
}
:host(:focus-within) ids-menu-button::part(button),
:host(:focus-visible) ids-menu-button::part(button) {
  color: var(--ids-search-field-button-color-text-hover);
}

:host(:active) ids-menu-button,
:host(:hover) ids-menu-button {
  border-color: var(--ids-search-field-color-border-hover);
}

.ids-input .ids-icon.starting-icon {
  margin: 0;
}

.ids-search-field .field-container {
  background-color: var(--ids-search-field-color-background-default);
  border-color: var(--ids-search-field-color-border-default);
  border-radius: var(--ids-search-field-border-radius);
  border-width: var(--ids-search-field-border-width);
  margin: var(--ids-search-field-margin);
  transition: all var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-search-field .field-container .truncated-wrapper {
  display: none;
}
.ids-search-field .field-container input {
  padding-inline-start: 4px;
}
.ids-search-field .field-container.collapsed, .ids-search-field .field-container.truncated {
  --ids-trigger-field-min-width: var(--ids-button-icon-width);
  border-color: var(--ids-color-transparent);
  min-width: var(--ids-button-icon-width);
  width: var(--ids-button-icon-width);
  transition: all 350ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ids-search-field .field-container.collapsed:hover, .ids-search-field .field-container.collapsed:not(:focus-within), .ids-search-field .field-container.truncated:hover, .ids-search-field .field-container.truncated:not(:focus-within) {
  border-color: var(--ids-color-transparent);
}
.ids-search-field .field-container.collapsed:focus, .ids-search-field .field-container.collapsed:focus-within, .ids-search-field .field-container.truncated:focus, .ids-search-field .field-container.truncated:focus-within {
  box-shadow: none;
  border-color: var(--ids-search-field-color-border-focus);
}
.ids-search-field .field-container.collapsed:focus .ids-input-field, .ids-search-field .field-container.collapsed:focus-within .ids-input-field, .ids-search-field .field-container.truncated:focus .ids-input-field, .ids-search-field .field-container.truncated:focus-within .ids-input-field {
  caret-color: var(--ids-search-field-color-border-focus);
}
.ids-search-field .field-container.collapsed .ids-input-field, .ids-search-field .field-container.truncated .ids-input-field {
  pointer-events: none;
  display: none;
  opacity: 0;
  transform: translateX(-12px);
  transition: opacity 280ms cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 350ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ids-search-field .field-container.collapsed .search-icon, .ids-search-field .field-container.truncated .search-icon {
  display: none;
}
.ids-search-field .field-container.collapsed .truncated-wrapper, .ids-search-field .field-container.truncated .truncated-wrapper {
  display: inline-flex;
  gap: var(--ids-space-2xs);
  height: var(--ids-search-field-truncated-wrapper-height);
  max-width: var(--ids-search-field-truncated-wrapper-width);
  border: 1px var(--ids-color-transparent);
  align-items: center;
}
.ids-search-field .field-container.collapsed .truncated-wrapper ids-text, .ids-search-field .field-container.truncated .truncated-wrapper ids-text {
  max-width: var(--ids-search-field-truncated-wrapper-text-width);
  cursor: pointer;
}
.ids-search-field .field-container.collapsed .truncated-wrapper .search-icon, .ids-search-field .field-container.truncated .truncated-wrapper .search-icon {
  display: inline-flex;
  cursor: pointer;
  margin: 0;
}
.ids-search-field .field-container.truncated {
  min-width: 70px;
}
.ids-search-field.ids-input.field-height-md .ids-input-field {
  height: var(--ids-input-height-30);
}
.ids-search-field.collapsed ids-trigger-button, .ids-search-field.truncated ids-trigger-button {
  width: var(--ids-button-icon-width);
}
.ids-search-field:has(.collapsed):not(.readonly):not(.disabled):not(:focus):not(:focus-within):hover .field-container, .ids-search-field:has(.truncated):not(.readonly):not(.disabled):not(:focus):not(:focus-within):hover .field-container {
  border-color: var(--ids-color-transparent);
}
.ids-search-field:has(.collapsed):focus-within .field-container, .ids-search-field:has(.truncated):focus-within .field-container {
  border-color: var(--ids-color-transparent);
}
.ids-search-field:has(.truncated) ids-menu-button {
  border-inline-end-color: var(--ids-color-transparent);
  margin-inline-end: 4px;
}
.ids-search-field ids-icon.search-icon {
  padding: var(--ids-space-xs);
  opacity: 1 !important;
  transform: none !important;
  transition: none !important;
}
.ids-search-field .fieldset {
  display: inline-flex;
  flex-direction: row;
  width: 100%;
}
.ids-search-field .fieldset ids-button {
  align-self: center;
}
@media (max-width: 767px) {
  .ids-search-field .fieldset {
    width: 95%;
  }
}
@media (max-width: 767px) {
  .ids-search-field.data-grid-personalization-search .fieldset {
    width: 100%;
  }
}
.ids-search-field #category-action-button::part(button) {
  padding: var(--ids-space-xs);
  margin-inline-start: var(--ids-search-field-icon-margin);
}
.ids-search-field.color-variant-card .field-container {
  background: var(--ids-search-field-card-color-background);
  color: var(--ids-search-field-card-color-text);
}
.ids-search-field.color-variant-card .btn-clear:hover {
  background-color: var(--ids-color-transparent);
}
.ids-search-field.color-variant-app-menu {
  color: var(--ids-search-field-app-menu-color-text);
}
.ids-search-field.color-variant-app-menu .field-container {
  border-style: none;
  border-radius: var(--ids-search-field-border-radius);
  background-color: var(--ids-search-field-app-menu-color-background);
  color: var(--ids-search-field-app-menu-color-text);
}
.ids-search-field.color-variant-app-menu .ids-input-field {
  color: var(--ids-search-field-app-menu-color-text);
}
.ids-search-field.color-variant-app-menu .btn-clear::part(button) {
  color: var(--ids-search-field-app-menu-color-icon-default);
}
.ids-search-field.color-variant-app-menu .btn-clear::part(button):hover {
  background-color: transparent;
}
.ids-search-field.color-variant-app-menu .btn-clear:hover {
  color: var(--ids-search-field-app-menu-color-icon-hover);
}
.ids-search-field.color-variant-app-menu ids-icon::part(search-icon) {
  color: var(--ids-search-field-app-menu-color-text);
}
.ids-search-field.color-variant-app-menu:focus-within ids-icon::part(search-icon) {
  color: var(--ids-search-field-app-menu-color-icon-hover);
}
.ids-search-field.color-variant-app-menu:focus-within .field-container, .ids-search-field.color-variant-app-menu.readonly:focus-within .field-container {
  box-shadow: var(--ids-search-field-app-menu-shadow-focus);
}
.ids-search-field.color-variant-module-nav .fieldset {
  display: contents;
}
.ids-search-field.color-variant-module-nav .field-container {
  background-color: var(--ids-module-nav-search-input-bg-color);
  color: var(--ids-module-nav-item-hover-text-color);
}
.ids-search-field.color-variant-module-nav .ids-input-field {
  padding-inline-start: var(--ids-module-nav-item-expanded-icon-text-space-size);
}
.ids-search-field.color-variant-module-nav.full .field-container {
  width: var(--ids-module-nav-search-input-width);
}
.ids-search-field.color-variant-module-nav:focus-within .field-container {
  background-color: var(--ids-module-nav-search-input-focused-bg-color);
  border-color: var(--ids-module-nav-item-selected-text-color);
}
.ids-search-field.color-variant-dropdown.ids-input:focus-within .field-container, .ids-search-field.color-variant-dropdown.ids-input.readonly:focus-within .field-container, .ids-search-field.color-variant-dropdown.ids-input.is-active .field-container {
  box-shadow: none;
}
.ids-search-field.color-variant-dropdown .field-container {
  border-radius: 0;
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border-bottom-color: var(--ids-dropdown-group-color-border);
}
.ids-search-field ids-popup[type=dropdown] {
  width: 300px;
}
@media (max-width: 767px) {
  .ids-search-field ids-popup[type=dropdown] {
    width: 285px;
    min-width: 285px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ids-search-field/ids-search-field.scss","webpack://./src/themes/mixins/ids-clearable-mixin.scss","webpack://./src/themes/mixins/ids-dirty-tracker-mixin.scss","webpack://./src/themes/mixins/ids-field-indicator-mixin.scss","webpack://./src/themes/mixins/ids-label-state-mixin.scss","webpack://./src/themes/mixins/ids-validation-mixin.scss","webpack://./src/themes/mixins/ids-core-mixins.scss","webpack://./src/themes/mixins/ids-label-position-mixin.scss","webpack://./src/components/ids-input/ids-input.scss","webpack://./src/themes/mixins/ids-error-tracker-mixin.scss","webpack://./src/components/ids-trigger-field/ids-trigger-field.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;AAOI;;;;EACE,UAAA;ADCN;ACCM;;;;EACE,aAAA;ADIR;ACDM;;;;EACE,sBAAA;EACA,cAAA;ADMR;ACCM;;EACE,aAAA;EACA,oBAAA;ADER;;ACMI;EACE,wBAAA;ADHN;ACKM;EACE,aAAA;EACA,WAAA;ADHR;;ACSA;EACE,YAAA;ADNF;;AEtCA;EACE,0CAAA;EACA,yCAAA;EAEA,kBAAA;EACA,8DAAA;EACA,MAAA;AFwCF;AEtCE;EACE,wBAAA;EACA,MAAA;AFwCJ;AErCE;EACE,qBAAA;AFuCJ;;AElCA;EACE,yBAAA;AFqCF;;AElCA;EACE,yBAAA;AFqCF;;AElCA;EACE,QAAA;EACA,wBAAA;AFqCF;AEnCE;EACE,QAAA;AFqCJ;;AGrEA;EACE,kBAAA;EACA,MAAA;EACA,oBAAA;AHwEF;AGtEE;EACE,wBAAA;EACA,MAAA;AHwEJ;;AGpEA;EACE,yDAAA;EACA,mBAAA;EACA,8EAAA;EACA,eAAA;EACA,sEAAA;AHuEF;;AGnDA;EAfE,sEAAA;AHsEF;AG7DE;EACE,2CAAA;AH+DJ;;AGtDA;EAnBE,+DAAA;AH6EF;AGpEE;EACE,oCAAA;AHsEJ;;AGzDA;EAvBE,kEAAA;AHoFF;AG3EE;EACE,uCAAA;AH6EJ;;AG5DA;EA3BE,kEAAA;AH2FF;AGlFE;EACE,uCAAA;AHoFJ;;AG/DA;EA/BE,kEAAA;AHkGF;AGzFE;EACE,uCAAA;AH2FJ;;AGlEA;EAnCE,gEAAA;AHyGF;AGhGE;EACE,qCAAA;AHkGJ;;AGpEE;EACE,aAAA;AHuEJ;;AIhIM;EACE,YAAA;AJmIR;;AI3HE;EACE,aAAA;AJ8HJ;;AK5IA;ECQE,mCAAA;EACA,kCAAA;EDNA,aAAA;EACA,+EAAA;EACA,gCAAA;EACA,sCAAA;AL+IF;AK7IE;EACE,oCAAA;AL+IJ;AK5IE;EACE,2CAAA;AL8IJ;AK3IE;EACE,uCAAA;AL6IJ;AK1IE;EACE,uCAAA;AL4IJ;AK1II;EACE,iCAAA;AL4IN;AKxIE;EACE,uCAAA;AL0IJ;AKxII;EACE,iCAAA;AL0IN;AKtIE;EACE,qCAAA;ALwIJ;AKtII;EACE,8BAAA;ALwIN;AKpIE;EACE,oCAAA;ALsIJ;AKpII;EACE,+BAAA;ALsIN;AKlIE;EACE,uCAAA;ALoIJ;AKlII;EACE,gCAAA;ALoIN;AKhIE;EACE,aAAA;ALkIJ;;AO5LE;;EAEE,aAAA;EACA,6CAAA;EACA,QAAA;AP+LJ;AO5LI;;EACE,6BAAA;EACA,6CAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;AP+LN;AO3LI;;EACE,WAAA;EACA,wCAAA;AP8LN;AO5LM;EAJF;;IAKI,sBAAA;EPgMN;AACF;AO7LI;;EACE,sBAAA;EACA,oDAAA;EACA,uDAAA;APgMN;AO7LI;;EACE,kBAAA;EACA,uBAAA;EACA,iDAAA;APgMN;AO7LI;;EACE,oBAAA;APgMN;AO9LM;EAHF;;IAII,oBAAA;EPkMN;AACF;AOhMM;EAPF;;IAQI,oBAAA;EPoMN;AACF;AOjMI;EACE;;IACE,cAAA;IACA,oBAAA;IACA,QAAA;EPoMN;EOjMI;;IACE,QAAA;EPoMN;EOjMI;;IACE,cAAA;IACA,eAAA;IACA,QAAA;IACA,oDAAA;EPoMN;EOhMM;;IACE,oDAAA;IACA,uDAAA;EPmMR;AACF;AO7LE;EACE,2BAAA;EACA,+BAAA;AP+LJ;AO7LI;EAJF;IAKI,aAAA;IACA,eAAA;IACA,+CAAA;EPgMJ;EO7LI;IACE,sCAAA;IAEA,6CAAA;IACA,uDAAA;IACA,sBAAA;EP8LN;EO3LI;IACE,OAAA;EP6LN;EO1LI;IACE,WAAA;IACA,0DAAA;IACA,uBAAA;EP4LN;EOzLI;IACE,WAAA;IACA,yBAAA;EP2LN;EOxLI;IACE,WAAA;EP0LN;AACF;;AOnLE;EACE,sBAAA;APsLJ;AOpLI;EAHF;IAII,aAAA;IACA,eAAA;IACA,+CAAA;EPuLJ;EOrLI;IACE,sCAAA;IAEA,6CAAA;IACA,uDAAA;IACA,sBAAA;EPsLN;EOnLI;IACE,OAAA;EPqLN;EOlLI;IACE,WAAA;IACA,0DAAA;IACA,uBAAA;EPoLN;EOjLI;IACE,WAAA;IACA,yBAAA;EPmLN;EOhLI;IACE,WAAA;EPkLN;AACF;;AO1KI;;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;AP8KN;AO5KM;EALF;;IAMI,2BAAA;EPgLN;AACF;AO9KM;EATF;;IAUI,2BAAA;EPkLN;AACF;AO/KQ;;EACE,oBAAA;APkLV;AO7KI;EAtBF;;IAuBI,cAAA;EPiLJ;AACF;AO/KI;EA1BF;;IA2BI,cAAA;EPmLJ;AACF;AOhLE;EACE,OAAA;APkLJ;;AO3KE;;;;EAEE,aAAA;EACA,iBAAA;APgLJ;AO9KI;;;;EACE,cAAA;APmLN;AOhLI;;;;EACE,YAAA;EACA,cAAA;APqLN;AOjLI;;;;EACE,WAAA;EACA,sBAAA;APsLN;AOlLE;;EACE,+BAAA;APqLJ;;AO/KE;;EAEE,aAAA;EACA,MAAA;EACA,0CAAA;EACA,sCAAA;APkLJ;AOhLI;;EACE,cAAA;EACA,WAAA;APmLN;AOhLI;;EACE,cAAA;EACA,WAAA;EACA,YAAA;APmLN;AOhLI;;EACE,iBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,wCAAA;APmLN;AOhLI;;EACE,cAAA;EACA,sBAAA;APmLN;;AO7KE;EACE;IACE,aAAA;IACA,+CAAA;EPgLJ;EO9KI;IACE,6BAAA;IACA,cAAA;EPgLN;EO7KI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;EP+KN;AACF;AO3KE;EACE;;IAEE,cAAA;EP6KJ;AACF;AO1KE;EACE;;IAEE,eAAA;EP4KJ;AACF;;AOvKE;EACE;IACE,aAAA;IACA,+CAAA;EP0KJ;EOxKI;IACE,6BAAA;IACA,cAAA;EP0KN;EOvKI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;EPyKN;AACF;;AOnKE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;APsKJ;AOpKI;;EACE,WAAA;EACA,cAAA;APuKN;AOpKI;;EACE,YAAA;EACA,cAAA;APuKN;AOnKI;;EACE,WAAA;EACA,sBAAA;APsKN;;AO9JE;;EACE,aAAA;APkKJ;;AO3JE;;EAEE,aAAA;AP8JJ;AO5JI;;EACE,cAAA;EACA,QAAA;AP+JN;AO5JI;;EACE,YAAA;EACA,cAAA;EACA,QAAA;AP+JN;AO3JE;EACE,+BAAA;AP6JJ;;AOxJE;EACE;IACE,aAAA;IACA,+CAAA;EP2JJ;EOzJI;IACE,6BAAA;IACA,oBAAA;IACA,cAAA;IACA,QAAA;EP2JN;EOxJI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;IACA,QAAA;EP0JN;AACF;;AOpJE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;APuJJ;AOrJI;;EACE,WAAA;EACA,cAAA;EACA,QAAA;APwJN;AOrJI;;EACE,YAAA;EACA,cAAA;EACA,QAAA;APwJN;AOpJI;;EACE,sBAAA;EACA,QAAA;APuJN;AOnJE;EACE,+BAAA;APqJJ;;AOjJA;EACE,sDAAA;APoJF;;AO3II;;;;EACE,4CAAA;APiJN;AO9II;;;;EACE,iBAAA;APmJN;;AO7IA;EAEI;IACE,+CAAA;EP+IJ;EO7II;IACE,2CAAA;EP+IN;AACF;AOzIA;EAEI;IACE,aAAA;IACA,eAAA;IACA,+CAAA;EP0IJ;EOxII;IACE,6BAAA;IACA,6CAAA;IACA,uDAAA;IACA,sBAAA;EP0IN;EOtII;IACE,kBAAA;IACA,0CAAA;EPwIN;EOpII;IACE,WAAA;IACA,wCAAA;EPsIN;AACF;AO/HE;EAEI;IACE,4CAAA;EPgIN;EO7HI;IACE,4BAAA;EP+HN;AACF;;AO1HA;EAEI;IACE,cAAA;EP4HJ;EOzHE;IACE,qBAAA;EP2HJ;AACF;AOrHA;EAGI;;IACE,aAAA;IACA,+CAAA;IACA,+BAAA;EPsHJ;EOpHI;;IACE,iCAAA;EPuHN;EOpHI;;IACE,aAAA;IACA,sBAAA;EPuHN;EOjHE;IACE,oBAAA;IACA,QAAA;EPmHJ;EOhHE;IACE,QAAA;EPkHJ;AACF;AO7GA;EAEI;IACE,aAAA;IACA,+CAAA;IACA,+BAAA;IACA,sBAAA;EP8GJ;EO5GI;IACE,iCAAA;IACA,QAAA;EP8GN;EO3GI;IACE,aAAA;IACA,sBAAA;IACA,QAAA;EP6GN;AACF;AOvGA;EACE;IACE,aAAA;IACA,eAAA;IACA,+CAAA;EPyGF;EOvGE;IACE,6BAAA;IACA,6CAAA;IACA,uDAAA;IACA,uBAAA;IACA,sBAAA;EPyGJ;EOtGE;IACE,WAAA;IACA,YAAA;EPwGJ;EOnGE;IACE,UAAA;IACA,cAAA;EPqGJ;AACF;AOhGA;EACE;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,+CAAA;EPkGF;EOhGE;IACE,6BAAA;IACA,6CAAA;IACA,sBAAA;IACA,mBAAA;IACA,mBAAA;EPkGJ;EO/FE;;IAEE,aAAA;IACA,6CAAA;EPiGJ;AACF;AO5FA;EAEI;;;IAGE,cAAA;IACA,sBAAA;IACA,kBAAA;EP6FJ;EO3FI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;EP+FN;EO5FI;;;IACE,sBAAA;EPgGN;EO1FE;;;IAGE,cAAA;IACA,sBAAA;IACA,kBAAA;IACA,+BAAA;EP4FJ;EO1FI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;EP8FN;EO3FI;;;IACE,sBAAA;EP+FN;AACF;AOjFI;;;;;;;;;;;;;;EAEE,6BAAA;AP+FN;;AQxoBA,sBAAA;AAKA,qBAAA;AA6BA,oDAAA;AACA;EF1JE,mCAAA;EACA,kCAAA;EE4JA,+EAAA;EACA,gDAAA;EACA,aAAA;EACA,gDAAA;EACA,qBAAA;EAGA,wBAAA;ARymBF;AQtmBE;EACE,cAAA;ARwmBJ;AQnmBI;EACE,YAAA;ARqmBN;AQhmBI;EACE,kBAAA;EACA,+EAAA;EACA,yCAAA;EACA,uCAAA;EACA,kCAAA;EACA,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,QAAA;EAGA,cAAA;ARgmBN;AQ7lBI;EAEE,WAAA;AR8lBN;AQ1lBE;;EAEE,eAAA;AR4lBJ;;AQvlBE;EACE,iDAAA;EACA,0CAAA;AR0lBJ;AQxlBI;EACE,8DAAA;AR0lBN;;AQhkBA;EACE,cAAA;EACA,sCAAA;ARmkBF;AQjkBE;EACE,qBAAA;EACA,uCAAA;ARmkBJ;;AQ/jBA;EACE,aAAA;ARkkBF;;AQzjBE;;EAEE,uCAAA;AR4jBJ;;AQ9jBE;;EAEE,sCAAA;ARikBJ;;AQnkBE;;EAEE,sCAAA;ARskBJ;;AQxkBE;;EAEE,sCAAA;AR2kBJ;;AQ7kBE;;EAEE,qCAAA;ARglBJ;;AQllBE;;EAEE,qCAAA;ARqlBJ;;AQvlBE;;EAEE,qCAAA;AR0lBJ;;AQ5lBE;;EAEE,qCAAA;AR+lBJ;;AQjmBE;;EAEE,qCAAA;ARomBJ;;AQtmBE;;EAEE,sCAAA;ARymBJ;;AQ3mBE;;EAEE,sCAAA;AR8mBJ;;AQhnBE;;EAEE,sCAAA;ARmnBJ;;AQ9mBE;EACE,2DAAA;ARinBJ;AQ9mBE;EACE,2DAAA;ARgnBJ;;AQ3mBE;EACE,OAAA;EACA,YAAA;AR8mBJ;;AQ1mBA;EACE,WAAA;AR6mBF;;AQzmBE;EACE,uBAAA;AR4mBJ;;AQhzBE;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ARmzBJ;AQjzBI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;ARmzBN;AQhzBI;EACE,uCAAA;ARkzBN;AQhzBM;EACE,cAAA;EACA,yCAAA;ARkzBR;;AQx0BE;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AR20BJ;AQz0BI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AR20BN;AQx0BI;EACE,uCAAA;AR00BN;AQx0BM;EACE,cAAA;EACA,yCAAA;AR00BR;AQ3zBE;EACE,kDAAA;AR6zBJ;AQ1zBE;EACE,kDAAA;AR4zBJ;AQzzBE;EACE,kDAAA;AR2zBJ;AQxzBE;EACE,kDAAA;AR0zBJ;AQvzBE;EACE,kDAAA;ARyzBJ;AQtzBE;EACE,2BAAA;ARwzBJ;;AQ70BE;EACE,kDAAA;ARg1BJ;AQ70BE;EACE,kDAAA;AR+0BJ;AQ50BE;EACE,kDAAA;AR80BJ;AQ30BE;EACE,kDAAA;AR60BJ;AQ10BE;EACE,kDAAA;AR40BJ;AQz0BE;EACE,2BAAA;AR20BJ;AQjrBE;EACE,uBAAA;ARmrBJ;;AQ/qBA;EACE,kBAAA;EACA,cAAA;EACA,qCAAA;EACA,sCAAA;ARkrBF;AQ/qBE;EACE,iBAAA;EACA,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,sCAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;ARirBJ;AQ/qBI;EACE,4BAAA;EACA,0BAAA;ARirBN;AQ/qBM;EACG,yCAAA;ARirBT;AQ5qBE;EACE,4CAAA;AR8qBJ;AQxqBI;EACE,aAAA;EACA,2CAAA;AR0qBN;AQvqBI;EACE,iDAAA;EACA,gDAAA;EACA,2DAAA;ARyqBN;AQrqBE;EACE,wCAAA;ARuqBJ;AQpqBE;EACE,sCAAA;ARsqBJ;AQlqBE;EFhXA,mCAAA;EACA,kCAAA;EEkXE,sBAAA;EACA,8CAAA;EACA,YAAA;EACA,cAAA;EACA,+EAAA;EACA,yCAAA;EACA,uCAAA;EACA,yCAAA;EACA,uDAAA;EACA,qCAAA;EACA,WAAA;ARoqBJ;AQlqBI;EACE,aAAA;ARoqBN;AQprBE;EAmBE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;ARoqBJ;AQlqBI;EACE,uBAAA;ARoqBN;AQhqBI;EACE,iBAAA;ARkqBN;AQ/pBI;EACE,8CAAA;ARiqBN;AQ9pBI;EACE,kBAAA;ARgqBN;AQ7pBI;EACE,eAAA;AR+pBN;AQ1pBI;EACE,yCAAA;EACA,wCAAA;AR4pBN;AQvpBE;EACE,wCAAA;EACA,oCAAA;ARypBJ;AQvpBI;EACE,sBAAA;EACA,eAAA;ARypBN;AQlpBE;EAEE,cAAA;EACA,6BAAA;ARmpBJ;AQjpBI;EACE,uCAAA;ARmpBN;AQhpBI;EACE,oCAAA;ARkpBN;AQ/oBI;EACE,6BAAA;ARipBN;AQ7oBI;EACE,oCAAA;EACA,wCAAA;AR+oBN;AQ3oBM;EACE,6BAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;AR6oBR;AQroBI;;EAEE,sCA3diB;ARkmCvB;AQpoBI;EACE,0CA/diB;ARqmCvB;AQjoBI;EACE,sCApeiB;ARumCvB;AQhoBI;EACE,0CAxeiB;AR0mCvB;AQ7nBI;EACE,sCA5eiB;AR2mCvB;AQ5nBI;EACE,0CAhfiB;AR8mCvB;AQznBI;EACE,sCAvfiB;ARknCvB;AQxnBI;EACE,0CA3fiB;ARqnCvB;AQrnBI;EACE,sCA/fiB;ARsnCvB;AQpnBI;EACE,0CAngBiB;ARynCvB;AQlnBE;EACE,cAAA;ARonBJ;AQlnBI;;EAEE,kCAAA;ARonBN;AQhnBE;EAEI;;IAEE,0CArhBe;IAshBf,eAAA;ERinBN;EQ9mBI;IACE,cAAA;IACA,2CA3hBe;IA4hBf,sBAAA;ERgnBN;AACF;AQ1mBE;EA5UA,0CAAA;ARy7BF;AQv7BE;EACE,MAAA;ARy7BJ;AQt7BE;EACE,2CAAA;ARw7BJ;AQr7BE;EACE,0CAAA;EACA,wCAAA;EACA,cAAA;EACA,iBAAA;EACA,wCAAA;EACA,8CArO2B;AR4pC/B;AQxnBI;EACE,oCAAA;AR0nBN;AQxnBM;;EAEE,oCAAA;AR0nBR;AQrnBE;EACE,8CA9iB2B;ARqqC/B;AQpnBE;EACE,8CAjjB2B;ARuqC/B;AQnnBE;EACE,8CApjB2B;ARyqC/B;AQjnBE;EAtWA,0CAAA;AR09BF;AQx9BE;EACE,MAAA;AR09BJ;AQv9BE;EACE,2CAAA;ARy9BJ;AQt9BE;EACE,0CAAA;EACA,wCAAA;EACA,cAAA;EACA,iBAAA;EACA,wCAAA;EACA,8CArO2B;AR6rC/B;AQ/nBI;EACE,oCAAA;ARioBN;AQ/nBM;;EAEE,oCAAA;EACA,8CApkBuB;ARqsC/B;AQ7nBI;EACE,8CAAA;AR+nBN;AQxnBE;EACE,4DAAA;EAEA,WAAA;EACA,4CAAA;ARynBJ;AQvnBI;EACE,kCAAA;ARynBN;AQtnBI;;EAEE,aAAA;ARwnBN;AQrnBI;EACE,aAAA;ARunBN;AQpnBI;EACE,aAAA;ARsnBN;AQnnBI;EACE,aAAA;ARqnBN;AQlnBI;EACE,yDAAA;EACA,oCAAA;ARonBN;AQjnBI;EACE,gBAAA;ARmnBN;AQ/mBM;EACE,+CAAA;ARinBR;AQ5mBM;EACE,+CAAA;AR8mBR;AQzmBM;EACE,+CAAA;AR2mBR;AQtmBM;EACE,4CAAA;EACA,oCAAA;ARwmBR;AQrmBM;EACE,yCAAA;ARumBR;AQlmBM;EACE,4CAAA;EACA,oCAAA;ARomBR;AQjmBM;EACE,yCAAA;ARmmBR;AQ7lBE;EACE,WAAA;AR+lBJ;AQ7lBI;EACE,kCAAA;AR+lBN;AQ7lBM;EACE,mEAAA;EAEA,4CAAA;EACA,yBAAA;AR8lBR;AQ1lBI;EACE,aAAA;AR4lBN;AQzlBI;EACE,oBAAA;EACA,YAAA;AR2lBN;AQxlBI;EACE,kBAAA;EACA,cAAA;AR0lBN;AQvlBI;EACE,mBAAA;EACA,YAAA;ARylBN;AQtlBI;EACE,oCAAA;EACA,YAAA;ARwlBN;AQrlBI;EACE,mCAAA;ARulBN;AQplBI;EACE,mBAAA;EACA,YAAA;ARslBN;AQnlBI;EACE,kBAAA;ARqlBN;AQ/kBE;EACE,uCAAA;EACA,sMAAA;ARilBJ;AQ7kBI;EACE,yDAAA;EACA,kEAAA;AR+kBN;AQ5kBI;EACE,8CAAA;EACA,cAAA;AR8kBN;AQ5kBM;EACE,gEAAA;AR8kBR;AQ3kBM;EACE,oDAAA;AR6kBR;AQzkBI;EACE,mDAAA;AR2kBN;AQzkBM;EACE,iDAAA;AR2kBR;AQlkBI;EACE,2DAAA;EACA,mDAAA;EACA,0CAAA;ARokBN;AQ7jBQ;EAEE,4CAAA;EACA,qCAAA;AR8jBV;AQzjBQ;EAGE,4DAAA;ARyjBV;AQnjBM;EAGE,oDAAA;EACA,2CAAA;EACA,0CAAA;EAGA,6DAAA;ARijBR;AQ5iBM;EAGE,8CAAA;AR4iBR;AQxiBQ;EACE,8CAAA;AR0iBV;AQliBM;EACE,iDAAA;ARoiBR;AQ90CE;;;;;;;EAIE,yDAAA;EACA,gDAAA;ARm1CJ;AQj1CI;;;;;;;;;;;;;EAEE,yDAAA;EACA,2DAAA;AR81CN;AQ31CI;;;;;;;EACE,0DAAA;EACA,iDAAA;ARm2CN;AQ/1CE;;;EAEE,yDAAA;EACA,sDAAA;ARk2CJ;AQh2CI;;;EACE,yDAAA;EACA,sDAAA;ARo2CN;AQj2CI;;;;;EAEE,yDAAA;EACA,iEAAA;ARs2CN;AQn2CI;;;EACE,0DAAA;EACA,mDAAA;ARu2CN;AQn2CE;;;EAEE,wDAAA;EACA,+CAAA;ARs2CJ;AQp2CI;;;;;EAEE,wDAAA;EACA,0DAAA;ARy2CN;AQt2CI;;;EACE,yDAAA;EACA,gDAAA;AR02CN;AQt2CE;;;EAEE,2DAAA;EACA,kDAAA;ARy2CJ;AQv2CI;;;;;EAEE,2DAAA;EACA,6DAAA;AR42CN;AQz2CI;;;EACE,4DAAA;EACA,mDAAA;AR62CN;AQjoBM;EACE,iDAAA;ARmoBR;AQv7CE;;;;;;;EAIE,yDAAA;EACA,gDAAA;AR47CJ;AQ17CI;;;;;;;;;;;;;EAEE,yDAAA;EACA,2DAAA;ARu8CN;AQp8CI;;;;;;;EACE,0DAAA;EACA,iDAAA;AR48CN;AQx8CE;;;EAEE,yDAAA;EACA,sDAAA;AR28CJ;AQz8CI;;;EACE,yDAAA;EACA,sDAAA;AR68CN;AQ18CI;;;;;EAEE,yDAAA;EACA,iEAAA;AR+8CN;AQ58CI;;;EACE,0DAAA;EACA,mDAAA;ARg9CN;AQ58CE;;;EAEE,wDAAA;EACA,+CAAA;AR+8CJ;AQ78CI;;;;;EAEE,wDAAA;EACA,0DAAA;ARk9CN;AQ/8CI;;;EACE,yDAAA;EACA,gDAAA;ARm9CN;AQ/8CE;;;EAEE,2DAAA;EACA,kDAAA;ARk9CJ;AQh9CI;;;;;EAEE,2DAAA;EACA,6DAAA;ARq9CN;AQl9CI;;;EACE,4DAAA;EACA,mDAAA;ARs9CN;AQjuBM;EACE,kEAAA;ARmuBR;AQhiDE;;;;EAIE,yDAAA;EACA,gDAAA;ARkiDJ;AQhiDI;;;;;;;EAEE,yDAAA;EACA,2DAAA;ARuiDN;AQpiDI;;;;EACE,0DAAA;EACA,iDAAA;ARyiDN;AQriDE;;EAEE,yDAAA;EACA,sDAAA;ARuiDJ;AQriDI;;EACE,yDAAA;EACA,sDAAA;ARwiDN;AQriDI;;;EAEE,yDAAA;EACA,iEAAA;ARwiDN;AQriDI;;EACE,0DAAA;EACA,mDAAA;ARwiDN;AQpiDE;;EAEE,wDAAA;EACA,+CAAA;ARsiDJ;AQpiDI;;;EAEE,wDAAA;EACA,0DAAA;ARuiDN;AQpiDI;;EACE,yDAAA;EACA,gDAAA;ARuiDN;AQniDE;;EAEE,2DAAA;EACA,kDAAA;ARqiDJ;AQniDI;;;EAEE,2DAAA;EACA,6DAAA;ARsiDN;AQniDI;;EACE,4DAAA;EACA,mDAAA;ARsiDN;AQtyBI;EACE,kDAAA;EACA,iDAAA;EACA,0DAAA;EACA,6DAAA;EACA,gBAAA;ARwyBN;AQryBI;EACE,iDAAA;EACA,gDAAA;ARuyBN;AQpyBI;EACE,iDAAA;ARsyBN;AQpyBM;EACE,qDAAA;ARsyBR;AQjyBM;EACE,qDAAA;ARmyBR;AQ5xBI;EACE,oEAAA;EACA,oEAAA;EACA,2DAAA;AR8xBN;AQzxBM;EACE,kEAAA;AR2xBR;AQtxBM;EAGE,kEAAA;ARsxBR;AQnxBM;EACE,gDAAA;ARqxBR;AQ/wBM;EACE,qEAAA;EACA,4DAAA;ARixBR;AQ7wBI;EACE,6EAAA;EACA,qEAAA;EACA,4DAAA;AR+wBN;AQ5wBI;EACE,+DAAA;AR8wBN;AQxwBI;EACE,2CAAA;AR0wBN;AQpwBI;EACE,8CAAA;EACA,+CAAA;EACA,SAAA;ARswBN;AQ53CA;EA2nBE,uDAAA;ARowBF;AQnwBE;EACE,oDAAA;EAEA,uDAAA;ARowBJ;AQnwBI;EACE,8CAAA;EACA,0CAAA;EACA,cAAA;ARqwBN;AQlwBI;EACE,8CAAA;EACA,cAAA;ARowBN;AQlwBM;EACE,gEAAA;ARowBR;AQjwBM;EACE,oDAAA;ARmwBR;AQ9vBM;EACE,sBAAA;ARgwBR;AQ3vBM;EACE,mEAAA;AR6vBR;AQ1vBM;EACE,gEAAA;AR4vBR;AQzvBM;EACE,6CAAA;AR2vBR;AQpvBM;EACE,4DAAA;EACA,4DAAA;EACA,gBAAA;ARsvBR;AQnvBM;EACE,wEAAA;ARqvBR;AQlvBM;EACE,6CAAA;ARovBR;;AQ7uBE;EACE,uBAAA;ARgvBJ;AQ5uBE;EACE,aAAA;AR8uBJ;;AQ1uBA;EACE,yCAAA;EACA,uCAAA;AR6uBF;;AQ1uBA;EACE,wCAAA;AR6uBF;;AQ1uBA;EACE,yBAAA;AR6uBF;;AQ1uBA;EACE,yBAAA;AR6uBF;;AQ1uBA;EACE,wCAAA;AR6uBF;;AQ1uBA;;EAEE,gBAAA;AR6uBF;;AQzuBA;EACE,kBAAA;AR4uBF;;AQxuBA;EACE,WAAA;EACA,oCAAA;AR2uBF;;AQtuBE;EACE,aAAA;ARyuBJ;;AQruBA;EACE,oBAAA;ARwuBF;AQtuBE;EACE,eAAA;EACA,kBAAA;ARwuBJ;AQruBE;EACE,aAAA;ARuuBJ;AQpuBE;EACE,uBAAA;EACA,wCAAA;ARsuBJ;;AQjuBE;EACE,yCAAA;EACA,uCAAA;ARouBJ;;AQ/tBE;EACE,sCAAA;EACA,yCAAA;ARkuBJ;;AQ9tBA;EFzjCE,uDAAA;EACA,sBAAA;EACA,oCAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AN2xDF;;AQvuBA;;EAEE,2CAAA;AR0uBF;;AS/zDA;EACE,kBAAA;EACA,+EAAA;EACA,MAAA;EACA,oBAAA;ATk0DF;ASh0DE;EACE,wBAAA;EACA,MAAA;ATk0DJ;;AUt0DA;EACE,2BAAA;AVy0DF;;AUr0DA;EACE,mCAAA;EAEA,oBAAA;AVu0DF;AUr0DE;EACE,sBAAA;AVu0DJ;;AUn0DA;EACE,wBAAA;AVs0DF;AUl0DI;EACE,8CAAA;AVo0DN;AUh0DE;;EAEE,gBAAA;AVk0DJ;AU/zDE;EACE,6CAAA;EAEA,4CAAA;AVg0DJ;AU/zDI;EACE,oBAAA;EACA,UAAA;AVi0DN;AUv0DE;EASE,4CAAA;AVi0DJ;AUh0DI;EACE,oBAAA;EACA,UAAA;AVk0DN;;AU7zDA;EACE,sBAAA;EACA,WAAA;AVg0DF;;AU7zDA;EACE,sBAAA;EACA,WAAA;AVg0DF;;AU7zDA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AVg0DF;;AU7zDA;EACE,sBAAA;EACA,WAAA;AVg0DF;;AU3zDI;EACE,2CAAA;EACA,oDAAA;AV8zDN;AU3zDI;EACE,gBAAA;EACA,yEAAA;AV6zDN;AU1zDI;EACE,gBAAA;AV4zDN;;AUvzDA;EACE,aAAA;AV0zDF;;AUtzDE;EACE,iEAAA;AVyzDJ;AUtzDE;EACE,aAAA;AVwzDJ;;AUnzDE;EACE,aAAA;AVszDJ;;AUjzDE;EACE,cAAA;EACA,kBAAA;EACA,4CAAA;AVozDJ;;AU/yDE;EACE,qEAAA;AVkzDJ;AU/yDE;EACE,WAAA;AVizDJ;;AA93DA;EACE,gBAAA;AAi4DF;;AA73DE;EADF;IAEI,gBAAA;EAi4DF;AACF;AA/3DE;EACE,oEAAA;EACA,SAAA;EACA,gBAAA;EACA,yEAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;AAi4DJ;AA/3DI;EACE,oBAAA;EACA,kBAAA;EACA,uBAAA;AAi4DN;AA93DI;EACE,SAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,mDAAA;AAg4DN;AA93DM;EAGE,wCAAA;EACA,8CAAA;AA83DR;;AAv3DE;EACE,2DAAA;AA03DJ;AAx3DI;EACE,qBAAA;AA03DN;;AAn3DE;;EACE,wDAAA;AAu3DJ;AAr3DI;;EACE,sDAAA;AAw3DN;;AAj3DE;;EACE,wDAAA;AAq3DJ;;AAj3DA;EACE,SAAA;AAo3DF;;AAh3DE;EACE,kEAAA;EACA,0DAAA;EACA,oDAAA;EACA,kDAAA;EACA,sCAAA;EACA,iEAAA;AAm3DJ;AAj3DI;EACE,aAAA;AAm3DN;AAh3DI;EACE,yBAAA;AAk3DN;AA/2DI;EAEE,2DAAA;EAEA,0CAAA;EACA,uCAAA;EACA,mCAAA;EACA,0DAAA;AA+2DN;AA72DM;EAEE,0CAAA;AA82DR;AA32DM;EAEE,gBAAA;EACA,wDAAA;AA42DR;AA12DQ;EACE,uDAAA;AA42DV;AAx2DM;EACE,oBAAA;EACA,aAAA;EACA,UAAA;EACA,4BAAA;EACA,oHAAA;AA02DR;AAv2DM;EACE,aAAA;AAy2DR;AAt2DM;EACE,oBAAA;EACA,yBAAA;EACA,wDAAA;EACA,0DAAA;EACA,wCAAA;EACA,mBAAA;AAw2DR;AAt2DQ;EACE,+DAAA;EACA,eAAA;AAw2DV;AAr2DQ;EACE,oBAAA;EACA,eAAA;EACA,SAAA;AAu2DV;AAl2DI;EACE,eAAA;AAo2DN;AAh2DE;EACE,kCAAA;AAk2DJ;AA71DI;EACE,mCAAA;AA+1DN;AAv1DQ;EACE,0CAAA;AAy1DV;AAn1DM;EACE,0CAAA;AAq1DR;AA/0DI;EACE,qDAAA;EACA,sBAAA;AAi1DN;AA70DE;EACE,4BAAA;EACA,qBAAA;EACA,0BAAA;EACA,2BAAA;AA+0DJ;AA50DE;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;AA80DJ;AA50DI;EACE,kBAAA;AA80DN;AA30DI;EATF;IAUI,UAAA;EA80DJ;AACF;AA10DI;EADF;IAEI,WAAA;EA60DJ;AACF;AA10DE;EACE,4BAAA;EACA,wDAAA;AA40DJ;AAr0DI;EACE,yDAAA;EACA,8CAAA;AAu0DN;AAp0DI;EACE,8CAAA;AAs0DN;AAl0DE;EACE,kDAAA;AAo0DJ;AAl0DI;EACE,kBAAA;EACA,oDAAA;EACA,mEAAA;EACA,kDAAA;AAo0DN;AAj0DI;EACG,kDAAA;AAm0DP;AAh0DI;EACE,0DAAA;AAk0DN;AAh0DM;EACE,6BAAA;AAk0DR;AA9zDI;EACE,wDAAA;AAg0DN;AA7zDI;EACE,kDAAA;AA+zDN;AA1zDM;EACE,wDAAA;AA4zDR;AArzDM;EAtUJ,yDAAA;AA8nEF;AAhzDI;EACE,iBAAA;AAkzDN;AA/yDI;EACE,6DAAA;EACA,kDAAA;AAizDN;AA9yDI;EACE,8EAAA;AAgzDN;AA5yDM;EACE,+CAAA;AA8yDR;AAzyDM;EACE,qEAAA;EACA,4DAAA;AA2yDR;AApyDM;EACE,gBAAA;AAsyDR;AAlyDI;EACE,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,2DAAA;AAoyDN;AAhyDE;EACE,YAAA;AAkyDJ;AAhyDI;EAHF;IAII,YAAA;IACA,2BAAA;EAmyDJ;AACF","sourcesContent":["@use '../../themes/mixins/ids-core-mixins' as mixins;\n@use '../ids-trigger-field/ids-trigger-field' as *;\n\n// Applies to search fields in the app menu, which are\n// typically on top of black or dark color background\n@mixin ids-app-menu-search-field-shadow() {\n  box-shadow: var(--ids-search-field-app-menu-shadow-focus);\n}\n\n// Applies to both `dark` and `contrast` theme modes\n@mixin ids-search-field-dark-app-menu-colors() {\n  &.color-variant-app-menu {\n    color: var(--ids-search-field-app-menu-color-text);\n\n    .field-container {\n      background-color: var(--ids-search-field-app-menu-color-background);\n      color: var(--ids-search-field-app-menu-color-text);\n    }\n\n    .ids-input-field {\n      color: var(--ids-search-field-app-menu-color-text);\n    }\n\n    .btn-clear {\n      color: var(--ids-search-field-app-menu-color-icon-default);\n    }\n\n    .btn-clear:hover {\n      color: var(--ids-search-field-app-menu-color-icon-hover);\n    }\n\n    ids-icon::part(search-icon) {\n      color: var(--ids-search-field-app-menu-color-text);\n    }\n\n    &:focus-within {\n      ids-icon::part(search-icon) {\n        color: var(--ids-search-field-app-menu-color-icon-hover);\n      }\n    }\n\n    &:focus-within,\n    &.readonly:focus-within {\n      .field-container {\n        @include ids-app-menu-search-field-shadow();\n      }\n    }\n  }\n}\n\n.ids-search-field:focus-within ids-input::part(input) {\n  box-shadow: none;\n}\n\n:host {\n  @media (max-width: mixins.$breakpoint-sm) {\n    overflow: hidden;\n  }\n\n  ids-menu-button {\n    transition: border var(--ids-motion-duration) var(--ids-motion-ease);\n    border: 0;\n    border-inline: 0;\n    border-inline-end: 1px solid var(--ids-search-field-color-border-default);\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    margin: 0;\n    margin-inline: 0;\n    padding: 0;\n    padding-inline: 0;\n\n    & > * {\n      display: inline-flex;\n      align-self: center;\n      inset-inline-start: 5px;\n    }\n\n    &::part(button) {\n      border: 0;\n      border-radius: 0;\n      margin: 0;\n      margin-inline: 0;\n      padding: 0;\n      padding-inline: 0;\n      padding-inline: var(--ids-search-field-icon-margin);\n\n      &,\n      &:active,\n      &:hover {\n        background: var(--ids-color-transparent);\n        background-color: var(--ids-color-transparent);\n      }\n    }\n  }\n}\n\n:host([category]) {\n  ids-menu-button {\n    --ids-button-tertiary-shadow-focus: var(--ids-shadow-focus);\n\n    & > * {\n      inset-inline-start: 0;\n    }\n  }\n}\n\n:host(:focus-within),\n:host(:focus-visible) {\n  ids-menu-button {\n    border-color: var(--ids-search-field-color-border-focus);\n\n    &::part(button) {\n      color: var(--ids-search-field-button-color-text-hover);\n    }\n  }\n}\n\n:host(:active),\n:host(:hover) {\n  ids-menu-button {\n    border-color: var(--ids-search-field-color-border-hover);\n  }\n}\n\n.ids-input .ids-icon.starting-icon {\n  margin: 0;\n}\n\n.ids-search-field {\n  .field-container {\n    background-color: var(--ids-search-field-color-background-default);\n    border-color: var(--ids-search-field-color-border-default);\n    border-radius: var(--ids-search-field-border-radius);\n    border-width: var(--ids-search-field-border-width);\n    margin: var(--ids-search-field-margin);\n    transition: all var(--ids-motion-duration) var(--ids-motion-ease);\n\n    .truncated-wrapper {\n      display: none;\n    }\n\n    input {\n      padding-inline-start: 4px;\n    }\n\n    &.collapsed,\n    &.truncated {\n      --ids-trigger-field-min-width: var(--ids-button-icon-width);\n\n      border-color: var(--ids-color-transparent);\n      min-width: var(--ids-button-icon-width);\n      width: var(--ids-button-icon-width);\n      transition: all 350ms cubic-bezier(0.25, 0.46, 0.45, 0.94);\n\n      &:hover,\n      &:not(:focus-within) {\n        border-color: var(--ids-color-transparent);\n      }\n\n      &:focus,\n      &:focus-within {\n        box-shadow: none;\n        border-color: var(--ids-search-field-color-border-focus);\n\n        .ids-input-field {\n          caret-color: var(--ids-search-field-color-border-focus);\n        }\n      }\n\n      .ids-input-field {\n        pointer-events: none;\n        display: none;\n        opacity: 0;\n        transform: translateX(-12px);\n        transition: opacity 280ms cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 350ms cubic-bezier(0.25, 0.46, 0.45, 0.94);\n      }\n\n      .search-icon {\n        display: none;\n      }\n\n      .truncated-wrapper {\n        display: inline-flex;\n        gap: var(--ids-space-2xs);\n        height: var(--ids-search-field-truncated-wrapper-height);\n        max-width: var(--ids-search-field-truncated-wrapper-width);\n        border: 1px var(--ids-color-transparent);\n        align-items: center;\n\n        ids-text {\n          max-width: var(--ids-search-field-truncated-wrapper-text-width);\n          cursor: pointer;\n        }\n\n        .search-icon{\n          display: inline-flex;\n          cursor: pointer;\n          margin: 0;\n        }\n      }\n    }\n\n    &.truncated {\n      min-width: 70px;\n    }\n  }\n\n  &.ids-input.field-height-md .ids-input-field {\n    height: var(--ids-input-height-30);\n  }\n\n  &.collapsed,\n  &.truncated {\n    ids-trigger-button {\n      width: var(--ids-button-icon-width);\n    }\n  }\n\n  &:has(.collapsed),\n  &:has(.truncated) {\n    &:not(.readonly):not(.disabled):not(:focus):not(:focus-within) {\n      &:hover {\n        .field-container {\n          border-color: var(--ids-color-transparent);\n        }\n      }\n    }\n\n    &:focus-within {\n      .field-container {\n        border-color: var(--ids-color-transparent);\n      }\n    }\n  }\n\n  &:has(.truncated) {\n    ids-menu-button {\n      border-inline-end-color: var(--ids-color-transparent);\n      margin-inline-end: 4px;\n    }\n  }\n\n  ids-icon.search-icon {\n    padding: var(--ids-space-xs);\n    opacity: 1 !important;\n    transform: none !important;\n    transition: none !important;\n  }\n\n  .fieldset {\n    display: inline-flex;\n    flex-direction: row;\n    width: 100%;\n\n    ids-button {\n      align-self: center;\n    }\n\n    @media (max-width: mixins.$breakpoint-sm) {\n      width: 95%;\n    }\n  }\n\n  &.data-grid-personalization-search .fieldset {\n    @media (max-width: mixins.$breakpoint-sm) {\n      width: 100%;\n    }\n  }\n\n  #category-action-button::part(button) {\n    padding: var(--ids-space-xs);\n    margin-inline-start: var(--ids-search-field-icon-margin);\n  }\n\n  // =============================\n  // Default Styles for color variants (Applicable to all themes)\n\n  &.color-variant-card {\n    .field-container {\n      background: var(--ids-search-field-card-color-background);\n      color: var(--ids-search-field-card-color-text);\n    }\n\n    .btn-clear:hover {\n      background-color: var(--ids-color-transparent);\n    }\n  }\n\n  &.color-variant-app-menu {\n    color: var(--ids-search-field-app-menu-color-text);\n\n    .field-container {\n      border-style: none;\n      border-radius: var(--ids-search-field-border-radius);\n      background-color: var(--ids-search-field-app-menu-color-background);\n      color: var(--ids-search-field-app-menu-color-text);\n    }\n\n    .ids-input-field {\n       color: var(--ids-search-field-app-menu-color-text);\n    }\n\n    .btn-clear::part(button) {\n      color: var(--ids-search-field-app-menu-color-icon-default);\n\n      &:hover {\n        background-color: transparent;\n      }\n    }\n\n    .btn-clear:hover {\n      color: var(--ids-search-field-app-menu-color-icon-hover);\n    }\n\n    ids-icon::part(search-icon) {\n      color: var(--ids-search-field-app-menu-color-text);\n    }\n\n    &:focus-within {\n      // stylelint-disable-next-line\n      ids-icon::part(search-icon) {\n        color: var(--ids-search-field-app-menu-color-icon-hover);\n      }\n    }\n\n    &:focus-within,\n    &.readonly:focus-within {\n      // stylelint-disable-next-line\n      .field-container {\n        @include ids-app-menu-search-field-shadow();\n      }\n    }\n  }\n\n  // Ignore the fieldset element on Module Nav searchfields\n  &.color-variant-module-nav {\n    .fieldset {\n      display: contents;\n    }\n\n    .field-container {\n      background-color: var(--ids-module-nav-search-input-bg-color);\n      color: var(--ids-module-nav-item-hover-text-color);\n    }\n\n    .ids-input-field {\n      padding-inline-start: var(--ids-module-nav-item-expanded-icon-text-space-size);\n    }\n\n    &.full {\n      .field-container {\n        width: var(--ids-module-nav-search-input-width);\n      }\n    }\n\n    &:focus-within {\n      .field-container {\n        background-color: var(--ids-module-nav-search-input-focused-bg-color);\n        border-color: var(--ids-module-nav-item-selected-text-color);\n      }\n    }\n  }\n\n  &.color-variant-dropdown {\n    &.ids-input:focus-within, &.ids-input.readonly:focus-within, &.ids-input.is-active {\n      .field-container {\n        box-shadow: none;\n      }\n    }\n\n    .field-container {\n      border-radius: 0;\n      border-top-width: 0;\n      border-left-width: 0;\n      border-right-width: 0;\n      border-bottom-color: var(--ids-dropdown-group-color-border);\n    }\n  }\n\n  ids-popup[type='dropdown'] {\n    width: 300px;\n\n    @media (max-width: mixins.$breakpoint-sm) {\n      width: 285px;\n      min-width: 285px !important;\n    }\n  }\n}\n","/**\n * Css for clearable mixin\n */\n.ids-input,\n.ids-textarea {\n  .ids-input-field,\n  .ids-textarea-field {\n    .btn-clear {\n      outline: 0;\n\n      &.is-empty {\n        display: none;\n      }\n\n      [slot='icon'] {\n        margin-inline-start: 0;\n        color: inherit;\n      }\n    }\n  }\n\n  &.has-clearable {\n    .btn-clear {\n      &.is-empty {\n        display: none;\n        pointer-events: none;\n      }\n    }\n  }\n}\n\n.ids-trigger-field {\n  .ids-input-field {\n    &.has-clearable {\n      padding-inline-end: 55px;\n\n      ~ .btn-clear {\n        margin-top: 0;\n        right: -8px;\n      }\n    }\n  }\n}\n\n.btn-clear[part='clearable-button'] [slot='icon'] {\n  padding: 2px;\n}\n","// General Dirty-Tracker icon placement\n.icon-dirty {\n  --ids-icon-height-default: 12px !important;\n  --ids-icon-width-default: 12px !important;\n\n  position: absolute;\n  color: var(--ids-input-dirty-indicator-color-background-dirty);\n  top: 0;\n\n  &[dir='rtl'] {\n    transform: rotate(90deg);\n    top: 0;\n  }\n\n  &.tab-dirty-tracker {\n    inset-inline-start: 0;\n  }\n}\n\n// Color picker\n.ids-color-picker .icon-dirty {\n  margin-inline-start: 35px;\n}\n\n.ids-color-picker.compact .icon-dirty {\n  margin-inline-start: 27px;\n}\n\n.ids-textarea .icon-dirty {\n  top: 1px;\n  margin-inline-start: 1px;\n\n  &[dir='rtl'] {\n    top: 2px;\n  }\n}\n","// Field Indicator icon placement\n.icon-field-indicator {\n  position: absolute;\n  top: 0;\n  pointer-events: none;\n\n  &[dir='rtl'] {\n    transform: rotate(90deg);\n    top: 0;\n  }\n}\n\n.icon-field-indicator-info {\n  display: var(--ids-field-indicator-info-visibility, flex);\n  align-items: center;\n  margin-inline-end: var(--ids-field-indicator-info-margin, var(--ids-space-xs));\n  cursor: pointer;\n  color: var(--ids-field-indicator-icon-color, --ids-color-info-default);\n}\n\n// Mixin to apply field indicator color variables\n@mixin field-indicator-color($color, $border-color: null) {\n  --ids-field-indicator-icon-color: #{$color};\n\n  @if $border-color {\n    --ids-input-border-default-color: #{$border-color};\n    --ids-input-color-border-hover: #{$border-color};\n    --ids-input-color-border-disabled: #{$border-color};\n    --ids-input-color-border-focus: #{$border-color};\n  }\n\n  .icon-field-indicator {\n    color: #{$color};\n  }\n}\n\n// Field indicator type classes — applied to the field container.\n.field-indicator-neutral {\n  @include field-indicator-color(var(--ids-color-accent-neutral-weak));\n}\n\n.field-indicator-info {\n  @include field-indicator-color(var(--ids-color-info-default));\n}\n\n.field-indicator-success {\n  @include field-indicator-color(var(--ids-color-success-default));\n}\n\n.field-indicator-caution {\n  @include field-indicator-color(var(--ids-color-caution-default));\n}\n\n.field-indicator-warning {\n  @include field-indicator-color(var(--ids-color-warning-default));\n}\n\n.field-indicator-error {\n  @include field-indicator-color(var(--ids-color-error-default));\n}\n\n[class*=\"field-indicator-\"].has-focus {\n  .icon-field-indicator-info {\n    display: none;\n  }\n}\n","// When a label is just \"hidden\" it still takes up physical space to remain\n// in alignment with other input fields in a form that may have visible labels.\n// This simulates standard label text size while empty with a non-breaking space\n.label-state-hidden {\n  .ids-label-text {\n    &.empty {\n      &::before {\n        content: '\\00a0';\n      }\n    }\n  }\n}\n\n// When a label is \"collapsed\" simply don't display it\n.label-state-collapsed {\n  .ids-label-text {\n    display: none;\n  }\n}\n","@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n.validation-message {\n  @include mixins.antialiased();\n\n  display: flex;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  margin-top: var(--ids-space-2xs);\n  max-width: var(--ids-input-width-full);\n\n  &.has-custom-icon {\n    color: var(--ids-icon-color-default);\n  }\n\n  &.disabled {\n    color: var(--ids-input-color-text-disabled);\n  }\n\n  .ids-icon {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  &.alert {\n    color: var(--ids-color-caution-default);\n\n    &.disabled {\n      color: var(--ids-color-yellow-30);\n    }\n  }\n\n  &.warning {\n    color: var(--ids-color-warning-default);\n\n    &.disabled {\n      color: var(--ids-color-orange-30);\n    }\n  }\n\n  &.error {\n    color: var(--ids-color-error-default);\n\n    &.disabled {\n      color: var(--ids-color-red-30);\n    }\n  }\n\n  &.info {\n    color: var(--ids-color-info-default);\n\n    &.disabled {\n      color: var(--ids-color-blue-30);\n    }\n  }\n\n  &.success {\n    color: var(--ids-color-success-default);\n\n    &.disabled {\n      color: var(--ids-color-green-30);\n    }\n  }\n\n  &[hidden] {\n    display: none;\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 2463px;\n$breakpoint-xl: 1183px;\n$breakpoint-lg: 928px;\n$breakpoint-md: 927px;\n$breakpoint-sm: 767px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  /* stylelint-disable-next-line property-no-deprecated */\n  clip: rect(0, 0, 0, 0);\n  color: var(--ids-color-text-default);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n","// Label position styles\n@use '../../themes/mixins/ids-core-mixins' as *;\n\n// Left aligned and Right Aligned Labels\n:host([label-position='inline-start']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    align-items: var(--ids-label-align-y, center);\n    gap: 8px;\n\n    // Adjust the label\n    label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      padding-inline-end: 0;\n      box-sizing: border-box;\n      flex-shrink: 0;\n    }\n\n    // Validation on the bottom\n    .validation-message {\n      width: 100%;\n      margin-block-start: var(--ids-space-2xs);\n\n      @media (max-width: $breakpoint-md) {\n        margin-inline-start: 0;\n      }\n    }\n\n    + .validation-message {\n      min-width: min-content;\n      margin-block-start: calc(0px - var(--ids-space-2xs));\n      margin-inline-start: calc(var(--ids-label-width) + 6px);\n    }\n\n    &.xs + .validation-message {\n      position: relative;\n      inset-inline-start: 6px;\n      margin-inline-start: calc(var(--ids-label-width));\n    }\n\n    .ids-label-text {\n      margin-bottom: unset;\n\n      @media (width > $breakpoint-xs) {\n        margin-inline-end: 0;\n      }\n\n      @container (width > $breakpoint-xs) {\n        margin-inline-end: 0;\n      }\n    }\n\n    @media (min-width: $breakpoint-sm) {\n      label {\n        flex: 0 0 auto;\n        margin-bottom: unset;\n        order: 1;\n      }\n\n      .field-container {\n        order: 2;\n      }\n\n      .validation-message {\n        flex: 1 1 100%;\n        min-width: 100%;\n        order: 3;\n        margin-block-start: calc(0px - var(--ids-space-2xs));\n      }\n\n      &.wrapped {\n        .validation-message {\n          margin-block-start: calc(0px - var(--ids-space-2xs));\n          margin-inline-start: calc(var(--ids-label-width) + 6px);\n        }\n      }\n    }\n  }\n\n\n  .ids-checkbox {\n    container-type: inline-size;\n    margin-top: var(--ids-space-00);\n\n    @container (width >= 200px) {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      // Adjust the label\n      label {\n        --ids-checkbox-padding-inline-start: 0;\n\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + 0.4rem);\n        margin-block-start: 3px;\n      }\n\n      input[type='checkbox'] ~ .checkmark {\n        left: unset;\n        inset-inline-end: -1.5rem;\n      }\n\n      label.required .label-checkbox::after {\n        right: 30px;\n      }\n    }\n  }\n}\n\n// Horizontal aligned: use viewport media query instead of container query\n:host([label-position='inline-start'][horizontal-aligned]) {\n  .ids-checkbox {\n    container-type: normal;\n\n    @media (width <= $breakpoint-xs) {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      label {\n        --ids-checkbox-padding-inline-start: 0;\n\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + 0.4rem);\n        margin-block-start: 3px;\n      }\n\n      input[type='checkbox'] ~ .checkmark {\n        left: unset;\n        inset-inline-end: -1.5rem;\n      }\n\n      label.required .label-checkbox::after {\n        right: 30px;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-alignment=\"end\"]) {\n  .ids-input,\n  .ids-textarea {\n    label {\n      display: inline-flex;\n      align-items: center;\n      justify-content: flex-end;\n\n      @container (width < #{$breakpoint-xs}) {\n        justify-content: flex-start;\n      }\n\n      @media (width < $breakpoint-xs) {\n        justify-content: flex-start;\n      }\n\n      &.required {\n        &::after {\n          margin-inline-end: 0;\n        }\n      }\n    }\n\n    @container (width < #{$breakpoint-xs}) {\n      display: block;\n    }\n\n    @media (width < $breakpoint-xs) {\n      display: block;\n    }\n  }\n\n  .field-container {\n    flex: 1;\n  }\n}\n\n// Label break behavior for inline-start position\n:host([label-position='inline-start'][label-break='shrink-value']:not([validation-message-count])),\n:host([label-position='inline-start'][label-break='shrink-value'][validation-message-count][error-tracker]) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-wrap: nowrap;\n\n    label {\n      flex-shrink: 0;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      width: auto;\n      margin-inline-start: 0;\n    }\n  }\n\n  .ids-input:not(.xs) {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n// When validation is present with shrink-value, use grid to keep field width stable\n:host([label-position='inline-start'][label-break='shrink-value'][validation-message-count]:not([error-tracker])) {\n  .ids-input,\n  .ids-textarea {\n    display: grid;\n    gap: 0;\n    grid-template-columns: auto minmax(0, 1fr);\n    column-gap: var(--ids-space-2, 0.5rem);\n\n    label {\n      grid-column: 1;\n      grid-row: 1;\n    }\n\n    .field-container {\n      grid-column: 2;\n      grid-row: 1;\n      min-width: 0;\n    }\n\n    .validation-message {\n      grid-column: 1 / -1;\n      grid-row: 2;\n      width: auto;\n      margin-inline-start: 0;\n      margin-block-start: var(--ids-space-2xs);\n    }\n\n    &.wrapped .validation-message {\n      grid-column: 2;\n      margin-inline-start: 0;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-value']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  @media (width < $breakpoint-xs) {\n    .ids-input,\n    .ids-textarea {\n      display: block;\n    }\n  }\n\n  @container (width < #{$breakpoint-xs}) {\n    .ids-input,\n    .ids-textarea {\n      flex-wrap: wrap;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-label']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex: 0 1 auto;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='break']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    label {\n      width: auto;\n      flex-shrink: 0;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      width: auto;\n      margin-inline-start: 0;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-width=\"0px\"]),\n:host([label-position='inline-start'][label-width=\"0\"]) {\n  // When a label is \"inline-start\" and `label-width=\"0px\"` simply don't display it\n  .ids-label-text {\n    display: none;\n  }\n}\n\n\n// Label break behavior for inline-end position\n:host([label-position='inline-end'][label-break='shrink-value']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n\n    label {\n      flex-shrink: 0;\n      order: 2;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n      order: 1;\n    }\n  }\n\n  .ids-input {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n:host([label-position='inline-end'][label-break='shrink-label']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        justify-content: end;\n        flex: 0 1 auto;\n        order: 2;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n        order: 1;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-end'][label-break='break']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    label {\n      width: auto;\n      flex-shrink: 0;\n      order: 2;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n      order: 1;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      margin-inline-start: 0;\n      order: 3;\n    }\n  }\n\n  .ids-input {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n:host([label-position=\"inline-start\"]) {\n  --ids-label-width: var(--ids-label-width-inline-start);\n}\n\n// When label-wrap constrains the label size, ensure it stays vertically centered\n// instead of stretching to fill the flex container height\n:host([label-position=\"inline-start\"][label-wrap=\"ellipsis-no-stretch\"]),\n:host([label-position=\"inline-start\"][label-wrap=\"wrap-no-stretch\"]) {\n  .ids-input,\n  .ids-textarea {\n    label {\n      align-self: var(--ids-label-align-y, center);\n    }\n\n    .ids-label-text {\n      overflow: visible;\n    }\n  }\n}\n\n// Text area\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) {\n    .ids-textarea {\n      max-width: calc(370px + var(--ids-label-width));\n\n      .textarea-field {\n        width: calc(370px + var(--ids-label-width));\n      }\n    }\n  }\n}\n\n// Filter field\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) {\n    .ids-filter-field {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      label {\n        width: var(--ids-label-width);\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      // Filter field specific rules\n      #operator-button {\n        position: relative;\n        inset-inline-start: var(--ids-label-width);\n      }\n\n      // Validation on the bottom\n      .validation-message {\n        width: 100%;\n        margin-block-start: var(--ids-space-2xs);\n      }\n    }\n  }\n}\n\n// Checkboxes\n:host([label-position='inline-start'][dir='rtl']) {\n  @media (width < $breakpoint-sm) {\n    .ids-checkbox {\n      label {\n        --ids-checkbox-padding-inline-start: inherit;\n      }\n\n      .validation-message {\n        margin-inline-start: initial;\n      }\n    }\n  }\n}\n\n@media (min-width: $breakpoint-sm) {\n  :host([label-position='inline-start'][dir='rtl']) .ids-checkbox {\n    input[type='checkbox'] ~ .checkmark {\n      right: initial;\n    }\n\n    .validation-message {\n      margin-block-start: 0;\n    }\n  }\n}\n\n\n// Radio buttons\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']),\n  :host([label-position='inline-end']) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n      gap: var(--ids-space-2, 0.5rem);\n\n      ids-text.group-label-text {\n        min-width: var(--ids-label-width);\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n      }\n    }\n  }\n\n  :host([label-position='inline-end']) .ids-radio-group {\n    ids-text.group-label-text {\n      justify-content: end;\n      order: 2;\n    }\n\n    slot {\n      order: 1;\n    }\n  }\n}\n\n\n@media (width < $breakpoint-sm) {\n  :host([label-position='inline-end']):not([label-break]) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n      gap: var(--ids-space-2, 0.5rem);\n      flex-direction: column;\n\n      ids-text.group-label-text {\n        min-width: var(--ids-label-width);\n        order: 2;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        order: 1;\n      }\n    }\n  }\n}\n\n// Switch\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) .ids-switch {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: var(--ids-label-align-y, baseline);\n\n    label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      padding-inline-end: var(--ids-label-padding-inline-end);\n      padding-inline-start: 0;\n      box-sizing: border-box;\n    }\n\n    input[type='checkbox'] ~ .slider {\n      left: unset;\n      right: -45px;\n    }\n  }\n\n  :host([label-position='inline-start'][dir='rtl']) .ids-switch {\n    input[type='checkbox'] ~ .slider {\n      left: 45px;\n      right: initial;\n    }\n  }\n}\n\n// Data Label\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) .ids-data-label {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: var(--ids-label-align-y, baseline);\n\n    .label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      box-sizing: border-box;\n      margin-block-end: 0;\n      white-space: nowrap;\n    }\n\n    .data,\n    .description {\n      display: flex;\n      padding-block: var(--ids-label-padding-block);\n    }\n  }\n}\n\n// Responsive behavior\n@media (max-width: $breakpoint-xs) {\n  :host([label-position=\"inline-start\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: block;\n      flex-direction: column;\n      align-items: unset;\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n\n  :host([label-position=\"inline-end\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: block;\n      flex-direction: column;\n      align-items: unset;\n      gap: var(--ids-space-2, 0.5rem);\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n}\n\n// Just the label width\n:host {\n  .ids-input,\n  .ids-textarea,\n  .ids-checkbox,\n  .ids-radio,\n  .ids-switch,\n  .ids-data-label,\n  .ids-filter-field {\n    label,\n    .label {\n      width: var(--ids-label-width);\n    }\n  }\n}\n","@use '../../themes/mixins/ids-core-mixins' as mixins;\n@use '../../themes/mixins/ids-clearable-mixin' as *;\n@use '../../themes/mixins/ids-dirty-tracker-mixin' as *;\n@use '../../themes/mixins/ids-field-indicator-mixin' as *;\n@use '../../themes/mixins/ids-label-state-mixin' as *;\n@use '../../themes/mixins/ids-validation-mixin' as *;\n@use '../../themes/mixins/ids-label-position-mixin.scss' as label-position;\n\n// These input field sizes come from the design tokens and are adjusted\n// here to account for 1px border size on top/bottom or left/right in some calculations.\n$border-input-size-xs: calc(var(--ids-input-width-10));\n$border-input-size-sm: calc(var(--ids-input-width-20));\n$border-input-size-md: calc(var(--ids-input-width-40));\n$border-input-size-mm: calc(var(--ids-input-width-30));\n$border-input-size-lg: calc(var(--ids-input-width-50));\n$border-input-field-height-xs: calc(var(--ids-input-height-10) - 4px);\n$border-input-field-height-sm: calc(var(--ids-input-height-20) - 2px);\n$border-input-field-height-md: calc(var(--ids-input-height-30) - 2px);\n$border-input-field-height-lg: calc(var(--ids-input-height-40) - 2px);\n$input-size-full: 100%;\n\n// Mixin for message styles: [alert, error, info, success]\n@mixin ids-input-message-styles {\n  .alert,\n  .alert:hover,\n  .warning,\n  .warning:hover  {\n    border-color: var(--ids-input-color-border-alert-default);\n    color: var(--ids-input-color-text-alert-default);\n\n    &:focus-within,\n    &.is-active {\n      border-color: var(--ids-input-color-border-alert-default);\n      box-shadow: var(--ids-input-shadow-alert-focus) 0 0 3px 2px;\n    }\n\n    &[disabled] {\n      border-color: var(--ids-input-color-border-alert-disabled);\n      color: var(--ids-input-color-text-alert-disabled);\n    }\n  }\n\n  .field-container.error,\n  .field-container.error:hover {\n    border-color: var(--ids-input-color-border-error-default);\n    color: var(--ids-input-error-color-text-error-default);\n\n    &.field-container:not(:focus-within) {\n      border-color: var(--ids-input-color-border-error-default);\n      color: var(--ids-input-error-color-text-error-default);\n    }\n\n    &:focus-within,\n    &.is-active {\n      border-color: var(--ids-input-color-border-error-default);\n      box-shadow: var(--ids-input-color-shadow-error-focus) 0 0 3px 2px;\n    }\n\n    &[disabled] {\n      border-color: var(--ids-input-color-border-error-disabled);\n      color: var(--ids-input-color-border-error-disabled);\n    }\n  }\n\n  .info,\n  .info:hover {\n    border-color: var(--ids-input-color-border-info-default);\n    color: var(--ids-input-color-text-info-default);\n\n    &:focus-within,\n    &.is-active {\n      border-color: var(--ids-input-color-border-info-default);\n      box-shadow: var(--ids-input-shadow-info-focus)  0 0 3px 2px;\n    }\n\n    &[disabled] {\n      border-color: var( --ids-input-color-border-info-disabled);\n      color: var(--ids-input-color-text-info-disabled);\n    }\n  }\n\n  .success,\n  .success:hover {\n    border-color: var(--ids-input-color-border-success-default);\n    color: var(--ids-input-color-text-success-default);\n\n    &:focus-within,\n    &.is-active {\n      border-color: var(--ids-input-color-border-success-default);\n      box-shadow: var(--ids-input-shadow-success-focus) 0 0 3px 2px;\n    }\n\n    &[disabled] {\n      border-color: var(--ids-input-color-border-success-disabled);\n      color: var(--ids-input-color-text-success-disabled);\n    }\n  }\n}\n\n// Mixin for label wrap ellipsis\n@mixin ids-input-label-wrap-ellipsis {\n  .ids-label-text {\n    display: flex;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    ids-text {\n      display: block;\n      width: fit-content;\n      max-width: 100%;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      min-width: 0;\n      flex-shrink: 1;\n    }\n\n    &.required {\n      padding-inline-end: var(--ids-space-xs);\n\n      &::after {\n        flex-shrink: 0;\n        margin-inline-start: var(--ids-space-3xs);\n      }\n    }\n  }\n}\n\n/* stylelint-disable */\n// Function to calculate width subtract pad\n@function ids-input-size-with-pad($width, $pad: 8px) {\n  @return calc($width - $pad);\n}\n/* stylelint-enable */\n\n// Mixin for label wrap no-stretch\n@mixin ids-input-label-wrap-no-stretch {\n  .xs .ids-label-text {\n    max-width: ids-input-size-with-pad($border-input-size-sm);\n  }\n\n  .sm .ids-label-text {\n    max-width: ids-input-size-with-pad($border-input-size-sm);\n  }\n\n  .mm .ids-label-text {\n    max-width: ids-input-size-with-pad($border-input-size-mm);\n  }\n\n  .md .ids-label-text {\n    max-width: ids-input-size-with-pad($border-input-size-md);\n  }\n\n  .lg .ids-label-text {\n    max-width: ids-input-size-with-pad($border-input-size-lg);\n  }\n\n  .full .ids-label-text {\n    max-width: ids-input-size-with-pad($input-size-full);\n  }\n}\n\n/* in case of external label in compound component */\n.ids-label-text {\n  @include mixins.antialiased();\n\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  color: var(--ids-input-label-color-text-default);\n  display: flex;\n  margin-block-end: var(--ids-input-margin-bottom);\n  align-items: baseline;\n\n  // Ability to center label from parent element\n  justify-content: inherit;\n\n  // Specific styles for labels inside ids-box component\n  &.ids-box-label {\n    display: block;\n  }\n\n  // Simulate standard label text size while empty with a non-breaking space\n  &.empty {\n    &::before {\n      content: '\\00a0';\n    }\n  }\n\n  &.required {\n    &::after {\n      position: relative;\n      font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n      margin-inline-start: var(--ids-space-3xs);\n      margin-inline-end: var(--ids-space-3xs);\n      font-size: var(--ids-font-size-md);\n      color: var(--ids-input-required-indicator-color-text-default);\n      content: '*';\n      margin-top: -10px;\n      top: 1px;\n\n      // Adding it so \"*\" sign doesn't change label text height\n      line-height: 0;\n    }\n\n    &.no-required-indicator::after,\n    &.empty::after {\n      content: '';\n    }\n  }\n\n  ids-text::part(text),\n  .ids-text {\n    display: inline;\n  }\n}\n\n.disabled {\n  .ids-label-text {\n    color: var(--ids-input-label-color-text-disabled);\n    opacity: var(--ids-input-disabled-opacity);\n\n    &.required::after {\n      color: var(--ids-input-required-indicator-color-text-disabled);\n    }\n  }\n}\n\n@mixin input-extra-small-height($h: $border-input-field-height-xs) {\n  margin-block-end: var(--ids-font-size-2xs);\n\n  .icon-dirty {\n    top: 0;\n  }\n\n  .ids-label-text {\n    font-size: var(--ids-input-label-font-size);\n  }\n\n  .ids-input-field {\n    padding-inline-start: var(--ids-space-2xs);\n    padding-inline-end: var(--ids-space-2xs);\n    padding-top: 0;\n    padding-bottom: 0;\n    font-size: var(--ids-input-font-size-sm);\n    height: $h;\n  }\n}\n\n:host {\n  display: block;\n  max-width: var(--ids-input-width-full);\n\n  .ids-input {\n    display: inline-block;\n    width: var(--ids-box-input-width, auto);\n  }\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n// margin-block-end token overrides — applied to the inner .ids-input container.\n// Both the host attribute selector (web component) and a CSS class (standalone CSS) are\n// supported. The :not([no-margins]) guard ensures no-margins always wins.\n$margin-block-end-tokens: 'none', '4xs', '3xs', '2xs', 'xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl';\n\n@each $token in $margin-block-end-tokens {\n  :host([margin-block-end='#{$token}']:not([no-margins])) .ids-input,\n  .ids-input.margin-block-end-#{$token}:not(.no-margins) {\n    margin-block-end: var(--ids-space-#{$token});\n  }\n}\n\n:host([label-position=\"inline-start\"]) {\n  .field-container {\n    justify-content: var(--ids-box-justify-content, flex-start);\n  }\n\n  .ids-input {\n    justify-content: var(--ids-box-justify-content, flex-start);\n  }\n}\n\n:host([label-position=\"inline-start\"][size=\"full\"]) {\n  .field-container {\n    flex: 1;\n    min-width: 0;\n  }\n}\n\n:host([size='full']) {\n  width: 100%;\n}\n\n:host([label-wrap='wrap']) {\n  .ids-label-text {\n    overflow-wrap: anywhere;\n  }\n}\n\n:host([label-wrap='ellipsis']) {\n  @include ids-input-label-wrap-ellipsis();\n}\n\n:host([label-wrap='ellipsis-no-stretch']) {\n  @include ids-input-label-wrap-ellipsis();\n  @include ids-input-label-wrap-no-stretch();\n}\n\n:host([label-wrap='wrap-no-stretch']) {\n  @include ids-input-label-wrap-no-stretch();\n\n  .ids-label-text {\n    overflow-wrap: anywhere;\n  }\n}\n\n.ids-input {\n  position: relative;\n  display: block;\n  margin-block-end: var(--ids-space-sm);\n  max-width: var(--ids-input-width-full);\n\n  // Applied to the wrapper element that wraps the input and other interactable elements\n  .field-container {\n    border: 1px solid;\n    border-collapse: separate;\n    border-radius: var(--ids-border-radius-2xs);\n    box-sizing: border-box;\n    color: inherit;\n    display: flex;\n    align-items: center;\n    margin: var(--ids-space-none);\n    max-width: var(--ids-input-width-full);\n    padding: var(--ids-space-none);\n    position: relative;\n    resize: none;\n    text-align: left;\n\n    &.ff-input-field {\n      border-start-start-radius: 0;\n      border-end-start-radius: 0;\n\n      .ids-input-field {\n         color: var(--ids-filter-field-text-color);\n      }\n    }\n  }\n\n  .field-container.square {\n    border-radius: var(--ids-border-radius-none);\n  }\n\n  &:focus-within,\n  &.readonly:focus-within,\n  &.is-active {\n    .ids-input-field {\n      outline: none;\n      outline-color: var(--ids-color-transparent);\n    }\n\n    .field-container {\n      border-color: var(--ids-input-color-border-focus);\n      box-shadow: var(--ids-input-color-border-shadow);\n      background-color: var(--ids-input-color-background-default);\n    }\n  }\n\n  .ids-icon.starting-icon {\n    margin-inline-start: var(--ids-space-xs);\n  }\n\n  .ids-icon.ending-icon {\n    margin-inline-end: var(--ids-space-xs);\n  }\n\n  // Applied to the shadow root's HTMLInputElement\n  .ids-input-field {\n    @include mixins.antialiased();\n\n    box-sizing: border-box;\n    background-color: var(--ids-color-transparent);\n    border: none;\n    color: inherit;\n    font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n    padding-block-start: var(--ids-space-2xs);\n    padding-block-end: var(--ids-space-2xs);\n    padding-inline-start: var(--ids-space-12);\n    padding-inline-end: var(--ids-input-padding-inline-end);\n    font-size: var(--ids-input-font-size);\n    width: 100%;\n\n    &:focus-visible {\n      outline: none;\n    }\n\n    appearance: none;\n    display: inline-block;\n    height: fit-content;\n    resize: none;\n    text-align: left;\n    text-overflow: ellipsis;\n\n    &.text-ellipsis {\n      text-overflow: ellipsis;\n    }\n\n    // input text-align: [start, center, end]\n    &.start {\n      text-align: start;\n    }\n\n    &::placeholder {\n      color: var(--ids-input-color-text-placeholder);\n    }\n\n    &.center {\n      text-align: center;\n    }\n\n    &.end {\n      text-align: end;\n    }\n  }\n\n  &.event-picker {\n    .ids-input-field {\n      padding-inline-start: var(--ids-space-xs);\n      padding-inline-end: var(--ids-space-2xs);\n    }\n  }\n\n  // Validation Messages are appended beneath the `.field-container`\n  .validation-message {\n    margin-block-start: var(--ids-space-2xs);\n    margin-bottom: var(--ids-space-none);\n\n    .ids-icon {\n      place-self: self-start;\n      margin-top: 1px;\n    }\n  }\n\n  // If `no-margins` is used:\n  // - margins are removed from component top/bottom\n  // - labels are visually hidden instead of displaying blank content for spacing\n  &.no-margins,\n  &.no-margins.compact {\n    display: block;\n    margin: var(--ids-space-none);\n\n    &.field-height-xs {\n      margin-block-end: var(--ids-space-none);\n    }\n\n    .field-container {\n      margin-bottom: var(--ids-space-none);\n    }\n\n    .ids-input-field {\n      margin: var(--ids-space-none);\n    }\n\n    // Reverse the margins on `ids-input[no-margins]` fields to have the bottom margin on top\n    .validation-message {\n      margin-bottom: var(--ids-space-none);\n      margin-block-start: var(--ids-space-2xs);\n    }\n\n    .ids-label-text {\n      &.empty {\n        margin: var(--ids-space-none);\n        display: none;\n        visibility: hidden;\n        height: 0;\n      }\n    }\n  }\n\n  // input sizes: [xs, sm, mm, md, lg, full]\n  // Subtracting 2 takes into account that the width includes the `.field-container` border on both sides.\n  &.xs {\n    .field-container,\n    .validation-message {\n      width: $border-input-size-xs;\n    }\n\n    .validation-message {\n      max-width: $border-input-size-xs;\n    }\n  }\n\n  &.sm {\n    .field-container{\n      width: $border-input-size-sm;\n    }\n\n    .validation-message {\n      max-width: $border-input-size-sm;\n    }\n  }\n\n  &.mm {\n    .field-container {\n      width: $border-input-size-mm;\n    }\n\n    .validation-message {\n      max-width: $border-input-size-mm;\n    }\n  }\n\n  &.md {\n    .field-container {\n      width: $border-input-size-md;\n    }\n\n    .validation-message {\n      max-width: $border-input-size-md;\n    }\n  }\n\n  &.lg {\n    .field-container {\n      width: $border-input-size-lg;\n    }\n\n    .validation-message {\n      max-width: $border-input-size-lg;\n    }\n  }\n\n  &.full {\n    display: block;\n\n    .field-container,\n    .validation-message {\n      width: var(--ids-input-width-full);\n    }\n  }\n\n  @media (max-width: mixins.$breakpoint-sm)  {\n    &:not(.full):not(.md):not(.mm):not(.sm):not(.xs):not(.lg) {\n      .field-container,\n      .validation-message {\n        max-width: $border-input-size-mm;\n        min-width: auto;\n      }\n\n      .field-container {\n        flex-shrink: 0;\n        flex-basis: $border-input-size-mm;\n        box-sizing: border-box;\n      }\n    }\n  }\n\n  // input field-heights: [xs, sm, md, lg]\n  // Subtracting 2 takes into account that the width includes the `.field-container` border on both sides.\n  &.field-height-xs {\n    @include input-extra-small-height();\n\n    &.no-margin-bottom {\n      margin-bottom: var(--ids-space-none);\n\n      .field-container,\n      .ids-input-field {\n        margin-bottom: var(--ids-space-none);\n      }\n    }\n  }\n\n  &.field-height-sm .ids-input-field {\n    height: $border-input-field-height-sm;\n  }\n\n  &.field-height-md .ids-input-field {\n    height: $border-input-field-height-md;\n  }\n\n  &.field-height-lg .ids-input-field {\n    height: $border-input-field-height-lg;\n  }\n\n  // input compact\n  &.compact {\n    @include input-extra-small-height($border-input-field-height-xs);\n\n    &.no-margin-bottom {\n      margin-bottom: var(--ids-space-none);\n\n      .field-container,\n      .ids-input-field {\n        margin-bottom: var(--ids-space-none);\n        height: $border-input-field-height-xs;\n      }\n    }\n\n    .field-container:not(.ff-input-field) {\n      height: calc(var(--ids-input-height-10) - 2px);\n    }\n  }\n\n  // Data Grid Variants\n\n  // Flush/Invisible Variant (used in IdsDataGrid cell editing)\n  &.color-variant-borderless {\n    --ids-input-color-border-focus: var(--ids-color-transparent);\n\n    margin: 1px;\n    border-radius: var(--ids-border-radius-none);\n\n    input {\n      font-size: var(--ids-font-size-sm);\n    }\n\n    slot[name=\"trigger-start\"],\n    slot[name=\"trigger-end\"] {\n      display: flex;\n    }\n\n    .ids-label-text {\n      display: none;\n    };\n\n    .icon-dirty {\n      display: none;\n    }\n\n    .validation-message {\n      display: none;\n    }\n\n    .field-container {\n      background-color: var(--ids-color-transparent) !important;\n      border-color: transparent !important;\n    }\n\n    &:focus-within .field-container {\n      box-shadow: none;\n    }\n\n    &.ids-input.field-height-lg {\n      .ids-input-field {\n        padding-inline: calc(var(--ids-space-sm) - 2px);\n      }\n    }\n\n    &.ids-input.field-height-md {\n      .ids-input-field {\n        padding-inline: calc(var(--ids-space-12) - 2px);\n      }\n    }\n\n    &.ids-input.field-height-sm {\n      .ids-input-field {\n        padding-inline: calc(var(--ids-space-xs) - 2px);\n      }\n    }\n\n    &.ids-input.field-height-xs {\n      .ids-input-field {\n        font-size: var(--ids-data-grid-font-size-sm);\n        padding-inline: var(--ids-space-3xs);\n      }\n\n      slot[name=\"trigger-end\"]  {\n        padding-inline-end: var(--ids-space-none);\n      }\n    }\n\n    &.ids-input.field-height-xxs {\n      .ids-input-field {\n        font-size: var(--ids-data-grid-font-size-sm);\n        padding-inline: var(--ids-space-4xs);\n      }\n\n      slot[name=\"trigger-end\"]  {\n        padding-inline-end: var(--ids-space-none);\n      }\n    }\n  }\n\n  // Flush/Invisible Variant (used in IdsDataGrid inline cell editing)\n  &.color-variant-in-cell {\n    margin: 1px;\n\n    input {\n      font-size: var(--ids-font-size-sm);\n\n      &[field-height='xxs'] {\n        --ids-dropdown-font-size-compact: var(--ids-data-grid-font-size-sm);\n\n        font-size: var(--ids-data-grid-font-size-sm);\n        padding-inline-start: 2px;\n      }\n    }\n\n    .validation-message {\n      display: none;\n    }\n\n    &.ids-input.field-height-lg .ids-input-field {\n      padding-inline: 11px;\n      height: 40px;\n    }\n\n    &.ids-input.full .field-container {\n      margin-inline: 3px;\n      width: initial;\n    }\n\n    &.ids-input.field-height-md .ids-input-field {\n      padding-inline: 6px;\n      height: 30px;\n    }\n\n    &.ids-input.field-height-sm .ids-input-field {\n      padding-inline: var(--ids-space-2xs);\n      height: 27px;\n    }\n\n    &.ids-input.field-height-sm.full .field-container {\n      margin-inline: var(--ids-space-3xs);\n    }\n\n    &.ids-input.field-height-xs .ids-input-field {\n      padding-inline: 1px;\n      height: 24px;\n    }\n\n    &.ids-input.field-height-xs.full .field-container {\n      margin-inline: 1px;\n    }\n  }\n\n  // Module Nav color variant\n  // (used in IdsDropdown/IdsSearchField located inside IdsModuleNav)\n  &.color-variant-module-nav {\n    margin-block-end: var(--ids-space-none);\n    transform: background-color var(--ids-motion-duration) var(--ids-motion-ease),\n      border-color var(--ids-motion-duration) var(--ids-motion-ease),\n      color var(--ids-motion-duration) var(--ids-motion-ease);\n\n    .field-container {\n      border-radius: var(--ids-module-nav-common-border-radius);\n      border: var(--ids-module-nav-input-border-width) solid transparent;\n    }\n\n    input {\n      background-color: var(--ids-color-transparent);\n      color: inherit;\n\n      &::placeholder {\n        color: var(--ids-module-nav-search-input-placeholder-text-color);\n      }\n\n      &:active {\n        color: var(--ids-module-nav-search-input-text-color);\n      }\n    }\n\n    &:not([class*=\"field-height-\"]) {\n      height: var(--ids-module-nav-search-wrapper-height);\n\n      input {\n        height: var(--ids-module-nav-search-input-height);\n      }\n    }\n  }\n\n  // =======================================================\n  // Color Styles\n\n  &:not([class*='color-variant-']) {\n    .field-container:not(:focus-within) {\n      background-color: var(--ids-input-color-background-default);\n      border-color: var(--ids-input-border-default-color);\n      color: var(--ids-input-color-text-default);\n    }\n\n    &.readonly {\n      .field-container,\n      &.hover .field-container,\n      &.focus-within .field-container {\n        &.error,\n        &.error:hover {\n          border-color: var(--ids-color-error-default);\n          color: var(--ids-color-error-default);\n        }\n      }\n\n      &:not(.readonly-background):not(.bg-transparent) {\n        .field-container,\n        &.hover .field-container,\n        &.focus-within .field-container {\n          background-color: var(--ids-input-color-background-readonly);\n        }\n      }\n    }\n\n    &.disabled {\n      .field-container,\n      &:hover .field-container,\n      &:focus-within .field-container {\n        border-color: var(--ids-input-color-border-disabled);\n        color: var(--ids-input-color-text-disabled);\n        opacity: var(--ids-input-disabled-opacity);\n\n        // Safari input text color\n        -webkit-text-fill-color: var(--ids-input-color-text-disabled);\n      }\n    }\n\n    &.bg-transparent {\n      .field-container,\n      &.readonly .field-container,\n      &.disabled .field-container {\n        background-color: var(--ids-color-transparent);\n      }\n\n      &:focus-within {\n        .field-container {\n          background-color: var(--ids-color-transparent);\n        }\n      }\n    }\n\n\n    &:hover:not(.readonly):not(.disabled):not(:focus):not(:focus-within),\n    &:hover.readonly.readonly-background:not(:focus):not(:focus-within) {\n      .field-container {\n        border-color: var(--ids-input-color-border-hover);\n      }\n\n      // Include error styles\n      @include ids-input-message-styles();\n    }\n\n    &.is-active,\n    &.is-active:hover.readonly.readonly-background {\n      .field-container {\n        border-color: var(--ids-input-color-border-focus);\n      }\n\n      // Include error styles\n      @include ids-input-message-styles();\n    }\n\n    &:hover:not(.disabled).readonly.readonly-background.color-variant-alternate-formatter {\n      .field-container {\n        border-color: var(--ids-data-grid-filter-input-color-border-hover);\n      }\n    }\n\n    // Include error styles\n    @include ids-input-message-styles();\n  }\n\n  // Alternate Color Variant (used in IdsHeader - Search)\n  &.color-variant-alternate {\n    .field-container {\n      border-color: var(--ids-input-header-color-border);\n      color: var(--ids-input-header-color-text-default);\n      background-color: var(--ids-input-header-color-background);\n      border-bottom: 1px solid var(--ids-input-header-color-border);\n      box-shadow: none;\n    }\n\n    &:focus-within .field-container {\n      border-color: var(--ids-input-color-border-focus);\n      box-shadow: var(--ids-input-color-border-shadow);\n    }\n\n    .ids-input-field {\n      color: var(--ids-input-header-color-text-default);\n\n      &::placeholder {\n        color: var(--ids-input-header-color-text-placeholder);\n      }\n    }\n\n    &.readonly-background {\n      .ids-input-field::placeholder {\n        color: var(--ids-input-header-color-text-placeholder);\n      }\n    }\n  }\n\n  // Alternate-formatter Color Variant (used in IdsDataGrid filter)\n  &.color-variant-alternate-formatter {\n    .field-container {\n      background-color: var(--ids-data-grid-filter-input-color-background);\n      border-color: var(--ids-data-grid-filter-input-color-border-default);\n      color: var(--ids-data-grid-filter-input-color-text-default);\n    }\n\n    &:hover.readonly.readonly-background,\n    &:hover:not(.readonly):not(.disabled) {\n      .field-container {\n        border-color: var(--ids-data-grid-filter-input-color-border-hover);\n      }\n    }\n\n    &:focus-within {\n      .field-container,\n      &:hover.readonly.readonly-background,\n      &:hover:not(.readonly):not(.disabled) .field-container {\n        border-color: var(--ids-data-grid-filter-input-color-border-focus);\n      }\n\n      .ids-input-field {\n        box-shadow: var(--ids-input-color-border-shadow);\n      }\n    }\n\n    &.disabled,\n    &.disabled:hover {\n      .field-container {\n        border-color: var(--ids-data-grid-filter-input-color-border-disabled);\n        color: var(--ids-data-grid-filter-input-color-text-disabled);\n      }\n    }\n\n    &.readonly:not(.readonly-background):not(.bg-transparent) .field-container {\n      background-color: var(--ids-data-grid-filter-input-color-background-readonly);\n      border-color: var(--ids-data-grid-filter-input-color-border-readonly);\n      color: var(--ids-data-grid-filter-input-color-text-readonly);\n    }\n\n    .ids-input-field::placeholder {\n      color: var(--ids-data-grid-filter-input-color-text-placeholder);\n    }\n  }\n\n  // App Menu\n  &.color-variant-app-menu {\n    .field-container {\n      color: var(--ids-input-color-text-app-menu);\n    }\n  }\n\n  // List Builder\n  &.color-variant-list-builder {\n    .field-container {\n      background-color: var(--ids-color-transparent);\n      color: var(--ids-list-builder-input-text-color);\n      border: 0;\n    }\n  }\n\n  // Module Nav\n  /* stylelint-disable-next-line no-duplicate-selectors */\n  &.color-variant-module-nav {\n    color: var(--ids-module-nav-search-input-text-color);\n\n    /* stylelint-disable-next-line no-duplicate-selectors */\n    .field-container {\n      background-color: var(--ids-color-transparent);\n      border-color: var(--ids-color-transparent);\n      color: inherit;\n    }\n\n    .ids-input-field {\n      background-color: var(--ids-color-transparent);\n      color: inherit;\n\n      &::placeholder {\n        color: var(--ids-module-nav-search-input-placeholder-text-color);\n      }\n\n      &:active {\n        color: var(--ids-module-nav-search-input-text-color);\n      }\n    }\n\n    &.has-clearable {\n      .btn-clear {\n        margin-inline-end: 5px;\n      }\n    }\n\n    &:hover {\n      .field-container {\n        background-color: var(--ids-module-nav-search-input-hover-bg-color);\n      }\n\n      .ids-input-field::placeholder {\n        color: var(--ids-module-nav-search-input-placeholder-text-color);\n      }\n\n      .ids-input-field {\n        color: var(--ids-module-nav-input-text-color);\n      }\n    }\n\n    &:focus-within,\n    &.readonly:focus-within,\n    &.is-active {\n      .field-container {\n        background-color: var(--ids-module-nav-input-focus-bg-color);\n        border-color: var(--ids-module-nav-item-selected-text-color);\n        box-shadow: none;\n      }\n\n      .ids-input-field::placeholder {\n        color: var(--ids-module-nav-search-input-focused-placeholder-text-color);\n      }\n\n      .ids-input-field {\n        color: var(--ids-module-nav-input-text-color);\n      }\n    }\n  }\n}\n\n:host(.tab-name-editor) {\n  .ids-input {\n    margin-block-end: unset;\n  }\n\n\n  .ids-label-text {\n    display: none;\n  }\n}\n\n.caps-lock-indicator {\n  padding-inline-start: var(--ids-space-xs);\n  padding-inline-end: var(--ids-space-xs);\n}\n\n.show-hide-password {\n  padding-inline-end: var(--ids-space-3xs);\n}\n\n.is-uppercase {\n  text-transform: uppercase;\n}\n\n.is-lowercase {\n  text-transform: lowercase;\n}\n\n.highlight {\n  font-weight: var(--ids-font-weight-bold);\n}\n\n.ids-input-field[type='number']::-webkit-inner-spin-button,\n.ids-input-field[type='number']::-webkit-outer-spin-button {\n  appearance: none;\n}\n\n// Remove Safari caps lock icon\n.ids-input-field::-webkit-caps-lock-indicator {\n  visibility: hidden;\n}\n\n// Autocomplete dropdown menu sizes\n:host ids-popup[type='dropdown'] {\n  width: 100%;\n  max-width: var(--ids-input-width-40);\n}\n\n// Loading Indicator\n:host(:not([show-loading-indicator='true'])) {\n  ::slotted(.slot-loading-indicator) {\n    display: none;\n  }\n}\n\n:host([show-loading-indicator='true']) {\n  pointer-events: none;\n\n  ::slotted(ids-loading-indicator) {\n    margin-top: 3px;\n    margin-bottom: 3px;\n  }\n\n  ::slotted(ids-trigger-button[slot='trigger-end']) {\n    display: none;\n  }\n\n  ::slotted(.slot-loading-indicator) {\n    margin-inline-end: 12px;\n    margin-inline-start: var(--ids-space-xs);\n  }\n}\n\n:host([show-loading-indicator='true'][field-height='xs']) {\n  ::slotted(.slot-loading-indicator) {\n    margin-inline-start: var(--ids-space-2xs);\n    margin-inline-end: var(--ids-space-2xs);\n  }\n}\n\n:host([show-loading-indicator='true'][field-height='sm']) {\n  ::slotted(.slot-loading-indicator) {\n    margin-inline-end: var(--ids-space-xs);\n    margin-inline-start: var(--ids-space-2xs);\n  }\n}\n\n::slotted(.audible) {\n  @include mixins.audible();\n}\n\n:host([field-indicator][readonly]),\n:host([field-indicator][disabled]) {\n  --ids-field-indicator-info-visibility: none;\n}\n","// General Error-Tracker icon placement\n.icon-error-tracker {\n  position: absolute;\n  color: var(--ids-input-error-tracker-color-background, var(--ids-color-red-60));\n  top: 0;\n  pointer-events: none;\n\n  &[dir='rtl'] {\n    transform: rotate(90deg);\n    top: 0;\n  }\n}\n","@use '../ids-input/ids-input' as *;\n@use '../../themes/mixins/ids-error-tracker-mixin' as *;\n@use '../../themes/mixins/ids-label-position-mixin.scss' as label-position;\n\n// Ability to center label\n:host([part='trigger-field']) {\n  justify-content: flex-start;\n}\n\n// Date picker filter in datagrid\n:host([data-filter-type]) {\n  --ids-trigger-field-min-width: 40px;\n\n  margin-inline-end: 0;\n\n  ::slotted(ids-trigger-button) {\n    margin-inline-end: 6px;\n  }\n}\n\n.ids-trigger-field {\n  justify-content: inherit;\n\n  &.compact,\n  &.field-height-xs {\n    .field-container {\n      height: calc(var(--ids-input-height-10) - 2px);\n    }\n  }\n\n  .field-container.square,\n  .filter-container.square {\n    border-radius: 0;\n  }\n\n  .field-container {\n    min-width: var(--ids-trigger-field-min-width);\n\n    /* Ensure dirty tracker icon stays visible */\n    .icon-dirty {\n      pointer-events: none;\n      z-index: 1;\n    }\n\n    /* Ensure error tracker icon stays visible */\n    .icon-error-tracker {\n      pointer-events: none;\n      z-index: 1;\n    }\n  }\n}\n\n::slotted(*[slot='trigger-end']:not(.spinbox-button)) {\n  margin-inline-end: 4px;\n  width: 24px;\n}\n\n::slotted(*[slot='trigger-end'].xs) {\n  margin-inline-end: 4px;\n  width: 24px;\n}\n\n::slotted(*[slot='trigger-end'].md) {\n  margin-inline-end: 4px;\n  width: 24px;\n  height: 24px;\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n\n::slotted(*[slot='trigger-end'][compact]) {\n  margin-inline-end: 6px;\n  width: 24px;\n}\n\n.ids-input.color-variant-alternate-formatter {\n  &:focus-within {\n    .field-container.is-focused {\n      border-color: var(--ids-color-border-focus);\n      box-shadow: var(--ids-accordion-header-shadow-focus);\n    }\n\n    .field-container.hide-focus {\n      box-shadow: none;\n      border-color: var(--ids-data-grid-filter-input-color-background-readonly);\n    }\n\n    .ids-input-field {\n      box-shadow: none;\n    }\n  }\n}\n\n.field-container.collapsed .btn-clear {\n  display: none;\n}\n\n.ids-input.color-variant-module-nav {\n  .field-container.is-focused {\n    outline: 1px solid var(--ids-module-nav-item-active-border-color);;\n  }\n\n  .field-container.hide-focus {\n    outline: none;\n  }\n}\n\n:host(:not([collapsed])) {\n  ::slotted(ids-trigger-button.expand-button) {\n    display: none;\n  }\n}\n\n:host([collapsed]) {\n  ::slotted(ids-trigger-button.expand-button) {\n    display: block;\n    position: relative;\n    top: var(--ids-trigger-button-offset-top, 0);\n  }\n}\n\n:host([combobox]) {\n  .field-container input {\n    border-inline-end: 1px solid var(--ids-trigger-field-combobox-border);\n  }\n\n  ::slotted(ids-trigger-button) {\n    width: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
